(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[414,598,53120],{

/***/ 10022:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/valuation",
      function () {
        return __webpack_require__(80487);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_valuation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/features/valuation/slice.ts
var slice = __webpack_require__(17712);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/slice.ts
var Valuation_slice = __webpack_require__(9139);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/valuation/components/Modal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 15px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px !important;\n  }\n\n  .ant-modal-header {\n    border-top-left-radius: 3px !important;\n    border-top-right-radius: 3px !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 16px 21px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var styled_Button = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b9895c1b-0"
})(_templateObject());
var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-b9895c1b-1"
})(_templateObject1());
var ModalFooterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9895c1b-2"
})(_templateObject2());
var ModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9895c1b-3"
})(_templateObject3());
var ModalTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "18px",
    family: "bold",
    align: "center",
    height: "40px"
}).withConfig({
    componentId: "sc-b9895c1b-4"
})(_templateObject4());


;// CONCATENATED MODULE: ./src/features/valuation/components/Modal/index.tsx
/* eslint-disable no-nested-ternary */ 





var SaveModal = function(param) {
    var isVisible = param.isVisible, isOverrideMode = param.isOverrideMode, isDeleteMode = param.isDeleteMode, modalTitle = param.modalTitle, cancelText = param.cancelText, onClickCancel = param.onClickCancel, okText = param.okText, onClickOk = param.onClickOk, initValuationName = param.initValuationName;
    var ref = (0,react.useState)(""), valuationName = ref[0], setValuationName = ref[1];
    (0,react.useEffect)(function() {
        setValuationName(initValuationName || "");
    }, [
        initValuationName
    ]);
    var onTypeValuationName = function(event) {
        var value = event.target.value;
        setValuationName(value);
    };
    var handleSubmit = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        onClickOk(valuationName.trim());
    };
    var ModalFooter = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalFooterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                type: "borderless",
                pl: "0px",
                pr: "0px",
                height: "35px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.dimgray */.Z.dimgray,
                    onClick: function() {
                        return onClickCancel();
                    },
                    children: cancelText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                type: "primary",
                pl: "0px",
                pr: "0px",
                height: "35px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "inherit",
                    onClick: function() {
                        onClickOk(valuationName.trim());
                    },
                    children: okText
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
        destroyOnClose: true,
        visible: isVisible,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
            children: modalTitle
        }),
        footer: ModalFooter,
        maskStyle: {
            backgroundColor: "rgba(0,0,0,0.8)"
        },
        onCancel: onClickCancel,
        centered: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContainer, {
            children: isOverrideMode ? 'Do you want to overwrite "'.concat(initValuationName, '" valuation?') : isDeleteMode ? 'Are you sure you want to delete "'.concat(initValuationName, '" valuation?') : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "8px",
                        children: "Valuation Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        autoFocus: true,
                        height: "32px",
                        width: "100%",
                        placeholder: "Valuation Name",
                        value: valuationName,
                        onChange: onTypeValuationName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "submit",
                        style: {
                            display: "none"
                        }
                    })
                ]
            })
        })
    });
};
SaveModal.defaultProps = {
    initValuationName: "",
    isOverrideMode: false,
    isDeleteMode: false
};
/* harmony default export */ var components_Modal = (SaveModal);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/features/valuation/components/Header/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  background: ",
        ";\n  border-radius: 2px;\n  padding: 15px 20px;\n  border: unset;\n  margin-bottom: unset;\n  font-family: var(--bold-font);\n  font-weight: 700;\n  color: ",
        ";\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 3px;\n\n  @media ",
        " {\n    margin-bottom: 16px;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 2px;\n  border: unset;\n  display: block;\n  margin-bottom: unset;\n  padding: 15px 20px;\n  position: relative;\n\n  @media ",
        " {\n    border: 1px solid ",
        ";\n    margin-bottom: 15px;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 16px;\n  cursor: pointer;\n  font-family: var(--bold-font);\n  font-weight: 700;\n  color: ",
        ";\n\n  &:nth-child(2) {\n    font-family: var(--regular-font);\n    font-weight: normal;\n    color: ",
        ";\n    font-size: 14px;\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n\n  > * {\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  > * :hover {\n    background: ",
        ";\n    color: ",
        ";\n    width: 100%;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 8px;\n  cursor: pointer;\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var STitleLabel = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-67c001a2-0"
})(styled_templateObject(), color/* default.light */.Z.light, color/* default.dimgray */.Z.dimgray, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);
var STitleOptions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67c001a2-1"
})(styled_templateObject1(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);
var STitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67c001a2-2"
})(styled_templateObject2(), color/* default.dimgray */.Z.dimgray, color/* default.midgray */.Z.midgray);
var SPopoverContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67c001a2-3"
})(styled_templateObject3(), color/* default.gainsboro */.Z.gainsboro, color/* default.aliceBlue */.Z.aliceBlue, color/* default.primary */.Z.primary);
var ListContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-67c001a2-4"
})(styled_templateObject4(), color/* default.aliceBlue */.Z.aliceBlue);


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
;// CONCATENATED MODULE: ./src/features/valuation/components/Header/ValuationItem.tsx








function ValuationItem(_param) {
    var onDelete = _param.onDelete, onClick = _param.onClick, template = _param.template, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onDelete",
        "onClick",
        "template"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "14px",
                height: "30px",
                as: "a",
                style: {
                    flex: 1
                },
                onClick: function() {
                    return onClick(template.id);
                },
                children: template.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                padding: "0 5px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                    className: "icon-widget_close",
                    color: color/* default.sunsetOrange */.Z.sunsetOrange,
                    hoverColor: color/* default.sunsetOrange */.Z.sunsetOrange,
                    size: "14px",
                    weight: "bold",
                    onClick: function() {
                        return onDelete(template.id, template.name);
                    }
                })
            })
        ]
    }));
}
/* harmony default export */ var Header_ValuationItem = (ValuationItem);

;// CONCATENATED MODULE: ./src/features/valuation/components/Header/PopoverValuation.tsx















function PopoverValuation(param) {
    var children = param.children;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl), _getValuationTemplate = ref.getValuationTemplate, valuationTemplates = _getValuationTemplate.data;
    var valuationDetail = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA).valuationDetail;
    var _actions = slice/* default.actions */.ZP.actions, resetValuationDetail = _actions.resetValuationDetail, resetValuationResult = _actions.resetValuationResult, resetTemplateResult = _actions.resetTemplateResult, resetValuationSymbol = _actions.resetValuationSymbol, setValuationMetric = _actions.setValuationMetric, setValuationSymbol = _actions.setValuationSymbol, setValuationNote = _actions.setValuationNote, setValuationResult = _actions.setValuationResult, setValuationMetricKeyword = _actions.setValuationMetricKeyword;
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)(""), selectedId = ref2[0], setSelectedId = ref2[1];
    var ref3 = (0,react.useState)(""), selectedName = ref3[0], setSelectedName = ref3[1];
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
            var getDetail, _payload, error, data, payloadMetric, resultData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* valuationEffects.getValuationDetailTemplate */.B9.getValuationDetailTemplate(id));
                    case 2:
                        getDetail = _ctx.sent;
                        _payload = getDetail.payload, error = _payload.error, data = _payload.data;
                        if (!error) {
                            payloadMetric = {
                                comp_id: data.metric.company.id,
                                item: data.metric.item
                            };
                            dispatch(setValuationMetric(payloadMetric));
                            dispatch(setValuationSymbol(data.metric.company));
                            resultData = data.result.reduce(function(obj, curr) {
                                // eslint-disable-next-line no-param-reassign
                                obj[curr.name] = curr.value;
                                return obj;
                            }, {});
                            dispatch(setValuationResult((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resultData), {
                                symbol: data.metric.company.symbol
                            })));
                            dispatch(setValuationNote(data.note));
                            dispatch(setValuationMetricKeyword(data.metric.company.symbol));
                            dispatch(resetTemplateResult());
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelect(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowDelete = function(id, name) {
        setVisible(true);
        setSelectedId(id);
        setSelectedName(name);
    };
    var handleDeleteValuation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, activeId, del, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        activeId = ((ref = valuationDetail.data) === null || ref === void 0 ? void 0 : (ref1 = ref.valuation) === null || ref1 === void 0 ? void 0 : ref1.id) || 0;
                        _ctx.next = 4;
                        return dispatch(slice/* valuationEffects.deleteValuationDetailTemplate */.B9.deleteValuationDetailTemplate(Number(selectedId)));
                    case 4:
                        del = _ctx.sent;
                        error = del.payload.error;
                        if (!error) {
                            setVisible(false);
                            (0,AlertErrorMessage/* default */.Z)("Template ".concat(selectedName, " has been deleted"), successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            // Re fetch the list
                            dispatch(Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate());
                            if (Number(selectedId) === Number(activeId)) {
                                // Reset state
                                dispatch(resetValuationSymbol());
                                dispatch(resetValuationDetail());
                                dispatch(resetValuationResult());
                                dispatch(resetTemplateResult());
                            }
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeleteValuation() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        setVisible(false);
        setSelectedId("");
        setSelectedName("");
    };
    var handleAddNew = function() {
        dispatch(resetValuationSymbol());
        dispatch(resetValuationDetail());
        dispatch(resetValuationResult());
        dispatch(resetTemplateResult());
        dispatch(setValuationNote(""));
        dispatch(setValuationMetricKeyword(""));
    };
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    overflow: "auto",
                    maxHeight: "100px"
                },
                children: valuationTemplates.map(function(template) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ValuationItem, {
                        template: template,
                        onDelete: handleShowDelete,
                        onClick: handleSelect
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    padding: "4px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    block: true,
                    onClick: handleAddNew,
                    children: "Create New Valuation"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                zIndex: 1,
                content: content,
                trigger: "click",
                placement: "bottomLeft",
                overlayStyle: {
                    width: "240px",
                    border: "solid 1px #dadada",
                    background: "#fff"
                },
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                isVisible: visible,
                cancelText: "CANCEL",
                okText: "DELETE",
                modalTitle: "Delete Valuation",
                onClickCancel: handleCancel,
                onClickOk: handleDeleteValuation,
                isDeleteMode: true,
                initValuationName: selectedName
            })
        ]
    });
}
/* harmony default export */ var Header_PopoverValuation = (PopoverValuation);

;// CONCATENATED MODULE: ./src/features/valuation/components/Header/index.tsx
















var ValuationHeader = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), isModalEditVisible = ref4[0], setIsModalEditVisible = ref4[1];
    // prettier-ignore
    var ref5 = (0,react.useState)(false), isModalDeleteVisible = ref5[0], setIsModalDeleteVisible = ref5[1];
    var ref6 = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA), valuationDetail = ref6.valuationDetail, valuationResult = ref6.valuationResult, valuationSymbol = ref6.valuationSymbol, valuationCreateTemplateResult = ref6.valuationCreateTemplateResult, metric = ref6.metric, note = ref6.note;
    var updateValuationDetailTemplate = slice/* valuationEffects.updateValuationDetailTemplate */.B9.updateValuationDetailTemplate, getValuationDetailTemplate = slice/* valuationEffects.getValuationDetailTemplate */.B9.getValuationDetailTemplate, deleteValuationDetailTemplate = slice/* valuationEffects.deleteValuationDetailTemplate */.B9.deleteValuationDetailTemplate;
    var _actions = slice/* default.actions */.ZP.actions, resetValuationDetail = _actions.resetValuationDetail, resetValuationResult = _actions.resetValuationResult, resetTemplateResult = _actions.resetTemplateResult, resetValuationSymbol = _actions.resetValuationSymbol;
    var getValuationList = Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        // Did mount
        dispatch(getValuationList());
    }, [
        dispatch
    ]);
    var onClickButtonPopover = function(type) {
        if (type === "edit") setIsModalEditVisible(true);
        if (type === "delete") setIsModalDeleteVisible(true);
    };
    var hideModal = function() {
        setIsModalEditVisible(false);
        setIsModalDeleteVisible(false);
    };
    var generateResult = function() {
        var dataValuationResult = valuationResult.data;
        var normalizeData = JSON.parse(JSON.stringify(dataValuationResult));
        delete normalizeData.symbol;
        delete normalizeData.symbol_2;
        delete normalizeData.symbol_3;
        delete normalizeData.country;
        delete normalizeData.exchange;
        return Object.keys(normalizeData).map(function(el) {
            return {
                name: el,
                value: normalizeData[el]
            };
        });
    };
    var getValuationDetail = function() {
        var ref;
        var dataCreate = valuationCreateTemplateResult.data;
        var dataValuation = valuationDetail.data;
        var id = (dataValuation === null || dataValuation === void 0 ? void 0 : (ref = dataValuation.valuation) === null || ref === void 0 ? void 0 : ref.id) || (dataCreate === null || dataCreate === void 0 ? void 0 : dataCreate.id);
        // @ts-ignore
        dispatch(getValuationDetailTemplate(id));
    };
    var updateValuation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(newValuationName) {
            var ref, dataCreate, dataValuation, result, payload, templateID, updated, _payload, error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        dataCreate = valuationCreateTemplateResult.data;
                        dataValuation = valuationDetail.data;
                        result = generateResult();
                        payload = {
                            name: newValuationName,
                            note: note,
                            metric: JSON.stringify(metric),
                            result: JSON.stringify(result)
                        };
                        templateID = (dataValuation === null || dataValuation === void 0 ? void 0 : (ref = dataValuation.valuation) === null || ref === void 0 ? void 0 : ref.id) || (dataCreate === null || dataCreate === void 0 ? void 0 : dataCreate.id);
                        _ctx.next = 8;
                        return dispatch(updateValuationDetailTemplate({
                            payload: payload,
                            templateID: templateID
                        }));
                    case 8:
                        updated = _ctx.sent;
                        _payload = updated.payload, error = _payload.error, message = _payload.message;
                        if (!error) {
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            hideModal();
                            getValuationDetail();
                            dispatch(getValuationList());
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updateValuation(newValuationName) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteValuation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, dataCreate, dataValuation, templateID, del, error, ref1, ref2, name;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        dataCreate = valuationCreateTemplateResult.data;
                        dataValuation = valuationDetail.data;
                        templateID = (dataValuation === null || dataValuation === void 0 ? void 0 : (ref = dataValuation.valuation) === null || ref === void 0 ? void 0 : ref.id) || (dataCreate === null || dataCreate === void 0 ? void 0 : dataCreate.id);
                        _ctx.next = 6;
                        return dispatch(deleteValuationDetailTemplate(templateID));
                    case 6:
                        del = _ctx.sent;
                        error = del.payload.error;
                        if (!error) {
                            ;
                            // Reset UI
                            dispatch(resetValuationDetail());
                            dispatch(resetValuationResult());
                            dispatch(resetTemplateResult());
                            dispatch(resetValuationSymbol());
                            hideModal();
                            name = (valuationDetail === null || valuationDetail === void 0 ? void 0 : (ref1 = valuationDetail.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.valuation) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
                            (0,AlertErrorMessage/* default */.Z)("Template ".concat(name, " has been deleted"), successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            // Get list
                            dispatch(getValuationList());
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteValuation() {
            return _ref.apply(this, arguments);
        };
    }();
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(SPopoverContent, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "100%",
                type: "borderless",
                onClick: function() {
                    onClickButtonPopover("edit");
                },
                children: "Edit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "100%",
                type: "borderless",
                onClick: function() {
                    onClickButtonPopover("delete");
                },
                children: "Delete"
            })
        ]
    });
    var headerOptions = /*#__PURE__*/ (0,jsx_runtime.jsxs)(STitleOptions, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(STitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_PopoverValuation, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-cy": data_cy/* default.VALUATION.HEADER_TITLE */.Z.VALUATION.HEADER_TITLE,
                            children: (ref = valuationDetail.data) === null || ref === void 0 ? void 0 : (ref1 = ref.valuation) === null || ref1 === void 0 ? void 0 : ref1.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                        zIndex: 1,
                        content: content,
                        trigger: "click",
                        placement: "bottomRight",
                        overlayStyle: {
                            width: "100px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-cy": data_cy/* default.VALUATION.HEADER_MORE_BUTTON */.Z.VALUATION.HEADER_MORE_BUTTON,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMoreOptions/* default */.Z, {
                                vertical: true
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(STitleWrapper, {
                children: "Created on ".concat((ref2 = valuationDetail.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.valuation) === null || ref3 === void 0 ? void 0 : ref3.created)
            })
        ]
    });
    if (Object.keys(valuationDetail.data).length) {
        var ref7, ref8, ref9, ref10;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                headerOptions,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                    isVisible: isModalEditVisible,
                    cancelText: "CANCEL",
                    okText: "UPDATE",
                    modalTitle: "Update Valuation Name",
                    onClickCancel: hideModal,
                    onClickOk: updateValuation,
                    initValuationName: (ref7 = valuationDetail.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.valuation) === null || ref8 === void 0 ? void 0 : ref8.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                    isVisible: isModalDeleteVisible,
                    cancelText: "CANCEL",
                    okText: "DELETE",
                    modalTitle: "Delete Valuation",
                    onClickCancel: hideModal,
                    onClickOk: deleteValuation,
                    isDeleteMode: true,
                    initValuationName: (ref9 = valuationDetail.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.valuation) === null || ref10 === void 0 ? void 0 : ref10.name
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(STitleLabel, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_PopoverValuation, {
            children: "Valuation Tools"
        })
    });
};
/* harmony default export */ var Header = (ValuationHeader);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Select.js
var Select = __webpack_require__(6305);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/features/valuation/components/Body/styled.ts
/* eslint-disable no-irregular-whitespace */ 
function Body_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-family: ProximaNovaRg;\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n  border-radius: 3px;\n"
    ]);
    Body_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Body_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n\n  h5 {\n    border-radius: 3px 3px 0 0 !important;\n  }\n"
    ]);
    Body_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Body_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    position: relative;\n    grid-template-columns: 49% 48%;\n    grid-column-gap: 30px;\n    "
    ]);
    Body_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Body_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  \xa0\xa0\xa0\xa0display:block;\n  \xa0\xa0\xa0\xa0grid-template-columns:unset;\n  \xa0\xa0\xa0\xa0grid-gap:unset;\n\n      ",
        " {\n        border:unset;\n      }\n\xa0\xa0\xa0\xa0"
    ]);
    Body_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Body_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  font-size: 14px;\n  color: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  > * {\n    font-size: 14px;\n    font-family: ProximaNovaRg;\n    background-color: ",
        ";\n  }\n"
    ]);
    Body_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  padding: 10px 20px 20px 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: fit-content;\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  border-left: unset;\n  border-right: unset;\n  border-radius: 3px;\n\n  h5 {\n    border-radius: 3px 3px 0 0 !important;\n  }\n\n    ",
        "\n    @media\n    ",
        " {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  padding: 10px 20px 20px 20px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: block;\n  font-size: 14px;\n  font-family: var(--bold-font);\n  font-weight: 700px;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  margin-bottom: 30px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var SLabelBody = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-556d143b-0"
})(Body_styled_templateObject(), color/* default.gainsboro */.Z.gainsboro, color/* default.light */.Z.light);
var SValuationBodyResult = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-1"
})(Body_styled_templateObject1(), color/* default.gainsboro */.Z.gainsboro);
// prettier-ignore
var SValuationBodyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-2"
})(Body_styled_templateObject4(), color/* default.highempahis */.Z.highempahis, function(param) {
    var isResultAvailable = param.isResultAvailable;
    return isResultAvailable && (0,styled_components_browser_esm/* css */.iv)(Body_styled_templateObject2());
}, function(param) {
    var isResultAvailable = param.isResultAvailable, isMobileView = param.isMobileView;
    return isResultAvailable && isMobileView && (0,styled_components_browser_esm/* css */.iv)(Body_styled_templateObject3(), SValuationBodyResult);
}, color/* default.light */.Z.light);
var SValuationFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-3"
})(_templateObject5());
// prettier-ignore
var SValuationBodyForm = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-4"
})(_templateObject7(), function(param) {
    var isResultAvailable = param.isResultAvailable;
    return isResultAvailable && (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
}, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);
var SValuationResultWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-5"
})(_templateObject8());
var Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function(props) {
    return {
        as: "label"
    };
}).withConfig({
    componentId: "sc-556d143b-6"
})(_templateObject9(), color/* default.dimgray */.Z.dimgray, // @ts-expect-error
function(param) {
    var mb = param.mb;
    return mb || "0px";
});
var StockValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-7"
})(_templateObject10());
var ConsensusTargetContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-8"
})(_templateObject11());
var NoteContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-556d143b-9"
})(_templateObject12());


;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMethod/index.tsx

function ValuationMethod_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  margin-bottom: 15px;\n\n  .ant-select-selector {\n    border-radius: 3px !important;\n  }\n"
    ]);
    ValuationMethod_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ValuationMethod_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n\n  & > span {\n    width: 100%;\n    margin: 10px 0px 15px 0px;\n    border-radius: 2px;\n  }\n"
    ]);
    ValuationMethod_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var Option = Select/* default.Option */.Z.Option;
var SSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-11cc3090-0"
})(ValuationMethod_templateObject());
var SSkeleton = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Input */.Z.Input).withConfig({
    componentId: "sc-11cc3090-1"
})(ValuationMethod_templateObject1());
var ValuationMethod = function() {
    var valuationMetricOptions = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA).valuationMetricOptions;
    var name = valuationMetricOptions.data.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                htmlFor: "method",
                children: "Valuation Method"
            }),
            name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SSelect, {
                id: "method",
                width: "100%",
                defaultValue: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                    value: name,
                    children: "Price to Earnings Method"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SSkeleton, {
                active: true
            })
        ]
    });
};
/* harmony default export */ var Body_ValuationMethod = (ValuationMethod);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/AutocompleteSymbol/index.tsx

function AutocompleteSymbol_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n  margin-bottom: 15px;\n"
    ]);
    AutocompleteSymbol_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var TagCompany = Tag/* default.Tag */.Z.Tag;
var SAutocomplete = (0,styled_components_browser_esm/* default */.ZP)(Autocomplete/* default */.Z).withConfig({
    componentId: "sc-b4c5880b-0"
})(AutocompleteSymbol_templateObject());
var prepareSuggestionData = function(companies) {
    return companies.map(function(company) {
        var name = company.name, desc = company.desc, id = company.id;
        return {
            value: name,
            companyid: id,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagCompany, {
                        size: "s",
                        type: "grey",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "10px",
                        size: "13px",
                        ellipsis: true,
                        children: desc
                    })
                ]
            })
        };
    });
};
var AutocompleteSymbol = function() {
    var ref = (0,react.useState)([]), companyOptions = ref[0], setCompanyOptions = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var getCompanySymbol = slice/* valuationEffects.getCompanySymbol */.B9.getCompanySymbol, getDefaultValuationMetric = slice/* valuationEffects.getDefaultValuationMetric */.B9.getDefaultValuationMetric;
    var _actions = slice/* default.actions */.ZP.actions, setValuationSymbol = _actions.setValuationSymbol, resetValuationResult = _actions.resetValuationResult, setValuationMetricKeyword = _actions.setValuationMetricKeyword;
    var ref1 = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA), companySymbols = ref1.companySymbols, valuationResult = ref1.valuationResult, valuationSymbol = ref1.valuationSymbol, valuationMetricKeyword = ref1.valuationMetricKeyword;
    var delayTimer = (0,react.useRef)(undefined);
    var symbol = valuationResult.data.symbol;
    var onTypeHandler = function(e) {
        var typedVal = e.target.value;
        dispatch(setValuationMetricKeyword(typedVal));
        // Reset result on change
        if (symbol || valuationSymbol.symbol) {
            dispatch(resetValuationResult());
            dispatch(setValuationSymbol({
                id: "",
                symbol: ""
            }));
        }
        // Trigger search options
        if (typedVal.length !== 0) {
            clearTimeout(delayTimer.current);
            delayTimer.current = setTimeout(function() {
                dispatch(getCompanySymbol(typedVal));
            }, 500);
        } else {
            setCompanyOptions([]);
        }
    };
    var onClickAutocomplete = function(companySymbol, options) {
        var companyid = options.companyid;
        dispatch(setValuationMetricKeyword(companySymbol));
        dispatch(resetValuationResult());
        dispatch(setValuationSymbol({
            id: companyid,
            symbol: companySymbol
        }));
        dispatch(getDefaultValuationMetric({
            symbol: companySymbol
        }));
    };
    (0,react.useEffect)(function() {
        var company = companySymbols.data.company;
        if (company === null || company === void 0 ? void 0 : company.length) {
            var companies = prepareSuggestionData(company);
            setCompanyOptions(companies);
        }
    }, [
        companySymbols
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                children: "Valuation Metric"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SAutocomplete, {
                options: companyOptions,
                // @ts-expect-error
                dropdownStyles: {
                    boxShadow: "unset",
                    minWidth: "260px",
                    maxWidth: "260px",
                    width: "auto"
                },
                onSelect: onClickAutocomplete,
                value: valuationMetricKeyword,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    value: valuationMetricKeyword,
                    placeholder: "Type the stock symbol ...",
                    onChange: onTypeHandler,
                    width: "100%",
                    required: true
                })
            })
        ]
    });
};
/* harmony default export */ var ValuationMetric_AutocompleteSymbol = (AutocompleteSymbol);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/@deprecated-ui/widget/Select.js
var widget_Select = __webpack_require__(48469);
;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/DropdownMetric/styled.ts

function DropdownMetric_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: solid 1px ",
        ";\n  margin-bottom: 15px;\n"
    ]);
    DropdownMetric_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DropdownMetric_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  .ant-select-selector {\n    border-bottom: none !important;\n  }\n"
    ]);
    DropdownMetric_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DropdownMetric_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50% !important;\n  border-bottom: none;\n  border-left: none;\n  input {\n    border-radius: 3px;\n  }\n"
    ]);
    DropdownMetric_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var MetricContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bac5fd18-0"
})(DropdownMetric_styled_templateObject(), color/* default.gainsboro */.Z.gainsboro);
var styled_Select = (0,styled_components_browser_esm/* default */.ZP)(widget_Select/* default */.Z).withConfig({
    componentId: "sc-bac5fd18-1"
})(DropdownMetric_styled_templateObject1());
var styled_Input = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-bac5fd18-2"
})(DropdownMetric_styled_templateObject2());


;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/DropdownMetric/Form/OptionGroup.tsx






var OptionGroup = function(_param) /*#__PURE__*/ {
    var children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Select.Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            height: "inherit",
            children: children
        })
    }));
};
/* harmony default export */ var Form_OptionGroup = (OptionGroup);

;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/DropdownMetric/Form/useValuationMetrics.ts


function useValuationMetrics() {
    var valuationMetricOptions = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA).valuationMetricOptions;
    var dataValuationMetrics = valuationMetricOptions.data;
    var getDefaultValueIndexMetrics = function(paramsMetrics) {
        if (paramsMetrics !== "multiple") {
            var findDataDefault = dataValuationMetrics.params[paramsMetrics].find(function(metrics) {
                return metrics.default;
            });
            return findDataDefault ? findDataDefault.fitem_id : "";
        }
        // special case for MULTIPLE
        return Object.keys(dataValuationMetrics.params.multiple).map(function(i) {
            var currentMultiple = dataValuationMetrics.params.multiple[i];
            if (Array.isArray(currentMultiple)) {
                var findDataDefault = currentMultiple.find(function(metrics) {
                    return metrics.default;
                });
                return findDataDefault ? findDataDefault.fitem_id : "";
            }
            return currentMultiple && currentMultiple.default ? currentMultiple.fitem_id : "";
        }).filter(function(multiple) {
            return multiple !== "";
        })[0];
    };
    return {
        metrics: dataValuationMetrics,
        getMetrics: getDefaultValueIndexMetrics
    };
}
/* harmony default export */ var Form_useValuationMetrics = (useValuationMetrics);

;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/DropdownMetric/Form/InputMetrics.tsx





function InputMetrics(param) {
    var disabled = param.disabled, metricsKey = param.metrics, selectValue = param.selectValue, value = param.value, onChange = param.onChange, onSelect = param.onSelect;
    var ref;
    var ref1 = Form_useValuationMetrics(), metrics = ref1.metrics, getMetrics = ref1.getMetrics;
    var options = (metrics === null || metrics === void 0 ? void 0 : (ref = metrics.params) === null || ref === void 0 ? void 0 : ref[metricsKey]) || [];
    var onChangeSelection = function(e) {
        if (disabled) {
            return;
        }
        onSelect(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        children: [
            metrics.params && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Select, {
                value: selectValue === 0 ? getMetrics(metricsKey) : selectValue,
                onSelect: onChangeSelection,
                style: {
                    minWidth: "50px"
                },
                children: options.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_OptionGroup, {
                        value: item.fitem_id,
                        children: item.fitem_name
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Input, {
                onChange: onChange,
                disabled: disabled,
                value: value
            })
        ]
    });
}
/* harmony default export */ var Form_InputMetrics = (InputMetrics);

;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/DropdownMetric/Form/InputMetricsMultiple.tsx





function InputMetricsMultiple(param) {
    var disabled = param.disabled, selectValue = param.selectValue, value = param.value, onChange = param.onChange, onSelect = param.onSelect;
    var ref;
    var ref1 = Form_useValuationMetrics(), metrics = ref1.metrics, getMetrics = ref1.getMetrics;
    var options = (metrics === null || metrics === void 0 ? void 0 : (ref = metrics.params) === null || ref === void 0 ? void 0 : ref.multiple) || {};
    var labelName = {
        year_one: "1 Year",
        year_three: "3 Year"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        children: [
            metrics.params && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Select, {
                // defaultValue={getDefaultValueIndexMetrics('MULTIPLE')}
                value: selectValue === 0 ? getMetrics("multiple") : selectValue,
                onSelect: onSelect,
                style: {
                    minWidth: "50px"
                },
                children: Object.keys(options).map(function(i) {
                    var currentMultiple = options[i];
                    if (Array.isArray(currentMultiple)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Select.OptGroup, {
                            label: labelName[i],
                            children: currentMultiple.map(function(dataMultiple) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_OptionGroup, {
                                    value: dataMultiple.fitem_id,
                                    children: dataMultiple.fitem_name
                                });
                            })
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_OptionGroup, {
                        value: currentMultiple.fitem_id,
                        children: currentMultiple.fitem_name
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Input, {
                onChange: onChange,
                disabled: disabled,
                value: value
            })
        ]
    });
}
/* harmony default export */ var Form_InputMetricsMultiple = (InputMetricsMultiple);

// EXTERNAL MODULE: ./src/lib/api/valuation.ts
var valuation = __webpack_require__(17065);
// EXTERNAL MODULE: ./src/hooks/usePreviousState.ts
var usePreviousState = __webpack_require__(74786);
;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationMetric/DropdownMetric/index.tsx












function DropdownMetric() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA), valuationSymbol = ref.valuationSymbol, valuationDefaultMetric = ref.valuationDefaultMetric, valuationResult = ref.valuationResult, valuationDetail = ref.valuationDetail;
    var createValuation = slice/* valuationEffects.createValuation */.B9.createValuation;
    var setValuationMetric = slice/* default.actions.setValuationMetric */.ZP.actions.setValuationMetric;
    // Form values
    var ref1 = (0,react.useState)(0), selectedEPS = ref1[0], setSelectedEPS = ref1[1];
    var ref2 = (0,react.useState)(""), valueEPS = ref2[0], setValueEPS = ref2[1];
    var ref3 = (0,react.useState)("CUSTOM"), selectedGrowth = ref3[0], setSelectedGrowth = ref3[1];
    var ref4 = (0,react.useState)(""), valueGrowth = ref4[0], setValueGrowth = ref4[1];
    var ref5 = (0,react.useState)(0), selectedMultiple = ref5[0], setSelectedMultiple = ref5[1];
    var ref6 = (0,react.useState)(""), valueMultiple = ref6[0], setValueMultiple = ref6[1];
    // Data extracted from selector
    var defaultMetrics = valuationDefaultMetric.data;
    var _data = valuationResult.data, resultSymbol = _data.symbol;
    var companySymbol = valuationSymbol.symbol;
    var valuationData = valuationDetail.data;
    var setGrowthId = function(growthId) {
        return growthId === "" || growthId === 0 ? "CUSTOM" : String(growthId);
    };
    (0,react.useEffect)(function() {
        if (defaultMetrics.length > 0) {
            var _defaultMetrics = (0,_sliced_to_array/* default */.Z)(defaultMetrics, 3), eps = _defaultMetrics[0], growth = _defaultMetrics[1], multiple = _defaultMetrics[2];
            setSelectedEPS(String(eps.id));
            setValueEPS(eps.value);
            setSelectedGrowth(setGrowthId(growth.id));
            setValueGrowth(growth.value);
            setSelectedMultiple(String(multiple.id));
            setValueMultiple(multiple.value);
        }
    }, [
        defaultMetrics
    ]);
    (0,react.useEffect)(function() {
        if (!resultSymbol && !companySymbol) {
            setSelectedEPS(0);
            setValueEPS("");
            setSelectedGrowth("CUSTOM");
            setValueGrowth("");
            setSelectedMultiple(0);
            setValueMultiple("");
        }
    }, [
        resultSymbol,
        companySymbol
    ]);
    var preValuation = (0,usePreviousState/* default */.Z)(valuationData.valuation);
    (0,react.useEffect)(function() {
        var ref;
        if ((preValuation === null || preValuation === void 0 ? void 0 : preValuation.id) !== ((ref = valuationData.valuation) === null || ref === void 0 ? void 0 : ref.id)) {
            if (valuationData.metric) {
                if (valuationData.metric.item.length > 0) {
                    var _item = (0,_sliced_to_array/* default */.Z)(valuationData.metric.item, 3), eps = _item[0], growth = _item[1], multiple = _item[2];
                    setSelectedEPS(String(eps.itemid));
                    setValueEPS(eps.value);
                    setSelectedGrowth(setGrowthId(growth.itemid));
                    setValueGrowth(growth.value);
                    setSelectedMultiple(String(multiple.itemid));
                    setValueMultiple(multiple.value);
                }
            }
        }
    }, [
        valuationData.valuation
    ]);
    var getMetricsData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
            var symbol, res, _data, error, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (valuationSymbol.symbol) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 2:
                        symbol = valuationSymbol.symbol;
                        _ctx.next = 5;
                        return valuation/* default.getValuationMetricPerID */.Z.getValuationMetricPerID(symbol, id);
                    case 5:
                        res = _ctx.sent;
                        if (res.data) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 8:
                        _data = res.data, error = _data.error, data = _data.data;
                        if (!error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 11:
                        return _ctx.abrupt("return", data[0]);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getMetricsData(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelectEPS = function(value) {
        setSelectedEPS(value);
        // if select id same with default, change value to default
        if (Number(value) === Number(defaultMetrics[0].id)) {
            setValueEPS(defaultMetrics[0].value);
        } else {
            setValueEPS("");
        }
    };
    var handleChangeEPS = function(e) {
        var inputedEPS = e.target.value.trim();
        setValueEPS(inputedEPS);
        // if inputed same with default, change select to custom
        if (inputedEPS !== defaultMetrics[0].value) {
            setSelectedEPS("CUSTOM");
        }
    };
    var handleSelectGrowth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSelectedGrowth(value);
                        if (!(value === defaultMetrics[1].id || value === false && defaultMetrics[1].id === "")) {
                            _ctx.next = 4;
                            break;
                        }
                        setValueGrowth(defaultMetrics[1].value);
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(value !== "CUSTOM")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return getMetricsData(value);
                    case 7:
                        data = _ctx.sent;
                        setValueGrowth((data === null || data === void 0 ? void 0 : data.value) || "");
                        return _ctx.abrupt("return");
                    case 10:
                        setValueGrowth("");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelectGrowth(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeGrowth = function(e) {
        var inputedGrowth = e.target.value.trim();
        setValueGrowth(inputedGrowth);
        // if inputed same with default, change select to custom
        if (inputedGrowth !== defaultMetrics[1].value) {
            setSelectedGrowth("CUSTOM");
        }
    };
    var handleSelectMultiple = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSelectedMultiple(value);
                        if (!(value === defaultMetrics[2].id)) {
                            _ctx.next = 4;
                            break;
                        }
                        setValueMultiple(defaultMetrics[2].value);
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(value !== "CUSTOM")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return getMetricsData(value);
                    case 7:
                        data = _ctx.sent;
                        setValueMultiple((data === null || data === void 0 ? void 0 : data.value) || "");
                        return _ctx.abrupt("return");
                    case 10:
                        setValueMultiple("");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelectMultiple(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeMultiple = function(e) {
        var inputedMultiple = e.target.value.trim();
        setValueMultiple(inputedMultiple);
        // if inputed same with default, change select to custom
        if (inputedMultiple !== defaultMetrics[2].value) {
            setSelectedMultiple("CUSTOM");
        }
    };
    var calculateValue = function() {
        var id = valuationSymbol.id;
        var payload = {
            symbol: valuationSymbol.symbol,
            eps_value: valueEPS,
            growth_value: valueGrowth,
            multiple_value: valueMultiple
        };
        var payloadMetric = {
            comp_id: id,
            item: [
                {
                    name: "EPS",
                    itemid: String(selectedEPS),
                    value: valueEPS
                },
                {
                    name: "GROWTH",
                    itemid: String(selectedGrowth),
                    value: valueGrowth
                },
                {
                    name: "MULTIPLE",
                    itemid: String(selectedMultiple),
                    value: valueMultiple
                }, 
            ]
        };
        if (valuationSymbol.symbol) {
            dispatch(createValuation(payload));
            dispatch(setValuationMetric(payloadMetric));
        }
    };
    var disabled = !valuationSymbol.symbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MetricContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_InputMetrics, {
                        metrics: "eps",
                        selectValue: selectedEPS,
                        value: valueEPS,
                        onChange: handleChangeEPS,
                        onSelect: handleSelectEPS,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_InputMetrics, {
                        metrics: "growth",
                        selectValue: selectedGrowth,
                        value: valueGrowth,
                        onChange: handleChangeGrowth,
                        onSelect: handleSelectGrowth,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_InputMetricsMultiple, {
                        selectValue: selectedMultiple,
                        value: valueMultiple,
                        onChange: handleChangeMultiple,
                        onSelect: handleSelectMultiple,
                        disabled: disabled
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "65px",
                htmlType: "submit",
                type: "primary",
                onClick: calculateValue,
                children: "Value"
            })
        ]
    });
}
/* harmony default export */ var ValuationMetric_DropdownMetric = (DropdownMetric);

;// CONCATENATED MODULE: ./src/features/valuation/components/Body/ValuationResult/index.tsx















var TextArea = Input/* default.TextArea */.Z.TextArea;
var ValuationResult = function() {
    var ref, ref1;
    var ref2 = (0,react.useState)(""), note = ref2[0], setNote = ref2[1];
    var ref3 = (0,react.useState)(false), isModalSaveVisible = ref3[0], setIsModalSaveVisible = ref3[1];
    var ref4 = (0,react.useState)(false), isModalOverwriteVisible = ref4[0], setIsModalOverwriteVisible = ref4[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref5 = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA), valuationResult = ref5.valuationResult, valuationSymbol = ref5.valuationSymbol, valuationCreateTemplateResult = ref5.valuationCreateTemplateResult, valuationUpdateTemplateResult = ref5.valuationUpdateTemplateResult, valuationDetail = ref5.valuationDetail, metric = ref5.metric, valuationNote = ref5.note;
    var setValuationNote = slice/* default.actions.setValuationNote */.ZP.actions.setValuationNote;
    var createValuationTemplete = slice/* valuationEffects.createValuationTemplete */.B9.createValuationTemplete, getValuationDetailTemplate = slice/* valuationEffects.getValuationDetailTemplate */.B9.getValuationDetailTemplate, updateValuationDetailTemplate = slice/* valuationEffects.updateValuationDetailTemplate */.B9.updateValuationDetailTemplate;
    var getValuationList = Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate;
    var _data = valuationResult.data, symbol = _data.symbol, targetPrice = _data.target_price, currentPrice = _data.current_price, marginSafety = _data.margin_safety, consensusHigh = _data.consensus_high, consensusMedium = _data.consensus_medium, consensusLow = _data.consensus_low;
    var onInput = function(event) {
        var value = event.target.value;
        setNote(value);
    };
    var onCancelModal = function() {
        setIsModalSaveVisible(false);
        setIsModalOverwriteVisible(false);
    };
    var onClickSave = function() {
        var data = valuationCreateTemplateResult.data;
        var dataValuation = valuationDetail.data;
        if (Object.keys(data).length === 0 && Object.keys(dataValuation).length === 0) {
            setIsModalSaveVisible(true);
        } else {
            setIsModalOverwriteVisible(true);
        }
    };
    var generateResult = function() {
        var data = valuationResult.data;
        var normalizeData = JSON.parse(JSON.stringify(data));
        delete normalizeData.symbol;
        delete normalizeData.symbol_2;
        delete normalizeData.symbol_3;
        delete normalizeData.country;
        delete normalizeData.exchange;
        return Object.keys(normalizeData).map(function(el) {
            return {
                name: el,
                value: normalizeData[el]
            };
        });
    };
    var onClickSaveOnModal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(valuationName) {
            var data, companyID, result, payload, resp, ref, dataValuation, _valuation, name, id;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = valuationDetail.data;
                        companyID = valuationSymbol.id;
                        result = generateResult();
                        payload = {
                            company_id: companyID,
                            name: valuationName,
                            note: note,
                            metric: JSON.stringify(metric),
                            result: JSON.stringify(result)
                        };
                        if (!(Object.keys(data).length === 0)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 7;
                        return dispatch(createValuationTemplete({
                            payload: payload
                        }));
                    case 7:
                        resp = _ctx.sent;
                        _ctx.next = 10;
                        return resp.payload;
                    case 10:
                        ref = _ctx.sent;
                        dataValuation = ref.data;
                        dispatch(setValuationNote(note));
                        if (dataValuation) setIsModalSaveVisible(false);
                        _ctx.next = 17;
                        break;
                    case 16:
                        {
                            _valuation = data.valuation, name = _valuation.name, id = _valuation.id;
                            payload.name = name;
                            // Delete company id upon update
                            delete payload.company_id;
                            // @ts-ignore
                            dispatch(updateValuationDetailTemplate({
                                payload: payload,
                                templateID: id
                            })).then(function() {
                                (0,AlertErrorMessage/* default */.Z)("Your template has been updated", successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                                dispatch(getValuationList());
                            });
                            dispatch(setValuationNote(note));
                            setIsModalOverwriteVisible(false);
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickSaveOnModal(valuationName) {
            return _ref.apply(this, arguments);
        };
    }();
    var getValuationDetail = function() {
        var data = valuationCreateTemplateResult.data;
        var id = data.id;
        dispatch(getValuationDetailTemplate(id));
    };
    (0,react.useEffect)(function() {
        var data = valuationCreateTemplateResult.data;
        if (Object.keys(data).length) {
            dispatch(getValuationList());
            getValuationDetail();
        }
    }, [
        valuationCreateTemplateResult
    ]);
    (0,react.useEffect)(function() {
        if (valuationNote !== undefined) {
            setNote(valuationNote);
        }
    }, [
        valuationNote
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockValueContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        mb: "16px",
                        children: "Stock Value"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "10px",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                width: "50%",
                                children: [
                                    "Target Price ",
                                    symbol
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: targetPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "10px",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                width: "50%",
                                children: [
                                    "Current Price ",
                                    symbol
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: currentPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "10px",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: "Potential Gain"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: "".concat(marginSafety, " %")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConsensusTargetContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        mb: "16px",
                        children: "Consensus Target"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "10px",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: "Consensus (High)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: consensusHigh
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "10px",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: "Consensus (Medium)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: consensusMedium
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "10px",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: "Consensus (Low)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "50%",
                                children: consensusLow
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NoteContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                        mb: "16px",
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, {
                        rows: 3,
                        value: note,
                        onChange: onInput
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                width: "50px",
                type: "primary",
                onClick: onClickSave,
                children: "Save"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                modalTitle: "Save New Valuation",
                cancelText: "CANCEL",
                isVisible: isModalSaveVisible,
                okText: "SAVE",
                onClickCancel: onCancelModal,
                onClickOk: function(value) {
                    onClickSaveOnModal(value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Modal, {
                modalTitle: "Overwrite Valuation?",
                cancelText: "CANCEL",
                isVisible: isModalOverwriteVisible,
                okText: "UPDATE",
                onClickCancel: onCancelModal,
                isOverrideMode: true,
                initValuationName: (ref = valuationDetail.data) === null || ref === void 0 ? void 0 : (ref1 = ref.valuation) === null || ref1 === void 0 ? void 0 : ref1.name,
                onClickOk: function(value) {
                    onClickSaveOnModal(value);
                }
            })
        ]
    });
};
/* harmony default export */ var Body_ValuationResult = (ValuationResult);

;// CONCATENATED MODULE: ./src/features/valuation/components/Body/index.tsx









var ValuationBody = function() {
    var getValuationMetrics = slice/* valuationEffects.getValuationMetrics */.B9.getValuationMetrics;
    var ref = (0,es/* useSelector */.v9)(slice/* valuationSelectors */.FA), valuationResult = ref.valuationResult, isMobileView = ref.isMobileView;
    var symbol = valuationResult.data.symbol;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch(getValuationMetrics());
    }, []);
    var handleSubmit = function(e) {
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SValuationBodyContainer, {
        isResultAvailable: Boolean(symbol),
        isMobileView: isMobileView,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SValuationBodyForm, {
                isResultAvailable: Boolean(symbol),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SLabelBody, {
                        children: "Method and Metric"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SValuationFormWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Body_ValuationMethod, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationMetric_AutocompleteSymbol, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationMetric_DropdownMetric, {})
                            ]
                        })
                    })
                ]
            }),
            symbol && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SValuationBodyResult, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SLabelBody, {
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SValuationResultWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body_ValuationResult, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Body = (ValuationBody);

// EXTERNAL MODULE: ./src/global/NotPro/index.tsx + 1 modules
var NotPro = __webpack_require__(89698);
// EXTERNAL MODULE: ./src/global/NotPro/styled.ts
var styled = __webpack_require__(92768);
;// CONCATENATED MODULE: ./src/features/valuation/styled.ts

function valuation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  margin-right: unset;\n"
    ]);
    valuation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function valuation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 1px solid ",
        ";\n      border-radius: 2px;\n      height: auto;\n      max-width: 1000px;\n    "
    ]);
    valuation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function valuation_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  max-width: none;\n\n  ",
        "\n"
    ]);
    valuation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function valuation_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0px;\n  padding: 50px 0;\n  width: 100%;\n"
    ]);
    valuation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ValutionPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6ce4a574-0"
})(valuation_styled_templateObject());
var CustomNotProWrapper = (0,styled_components_browser_esm/* default */.ZP)(styled/* NotProWrapper */.CW).withConfig({
    componentId: "sc-6ce4a574-1"
})(valuation_styled_templateObject2(), function(param) {
    var isPro = param.isPro;
    return !isPro && (0,styled_components_browser_esm/* css */.iv)(valuation_styled_templateObject1(), color/* default.gainsboro */.Z.gainsboro);
});
var NotProContainer = (0,styled_components_browser_esm/* default */.ZP)(NotPro/* default */.Z).withConfig({
    componentId: "sc-6ce4a574-2"
})(valuation_styled_templateObject3());

;// CONCATENATED MODULE: ./src/features/valuation/index.tsx







function Valuation() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var setIsMobileView = slice/* default.actions.setIsMobileView */.ZP.actions.setIsMobileView;
    (0,react.useEffect)(function() {
        var timeoutId = null;
        var checkWindowWidth = function() {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function() {
                var width = window.innerWidth;
                if (width <= 796) {
                    dispatch(setIsMobileView(true));
                } else {
                    dispatch(setIsMobileView(false));
                }
            }, 16);
        };
        window.addEventListener("resize", checkWindowWidth);
        window.addEventListener("DOMContentLoaded", checkWindowWidth);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValutionPageContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {})
        ]
    });
}
/* harmony default export */ var features_valuation = (Valuation);

// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 4 modules
var MainLayout = __webpack_require__(53120);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Page.tsx
var Page = __webpack_require__(16943);
;// CONCATENATED MODULE: ./pages/valuation.tsx

__webpack_require__(14473);






function ValuationPage() {
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Stockbit Valuation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout["default"], {
                isFlexibleWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                        loaded: isLoaded
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                        feature: "VALUATION",
                        isFlexible: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(features_valuation, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var pages_valuation = (ValuationPage);


/***/ }),

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 48253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* eslint-disable react/jsx-props-no-spreading */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  & > div {\n    display: ",
        ";\n    width: 5px;\n    height: 5px;\n    margin: 2px;\n    border-radius: 50%;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    shouldForwardProp: function(props) {
        return ![
            "vertical"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        vertical: props.vertical
    };
}).withConfig({
    componentId: "sc-fadbb486-0"
})(_templateObject(), function(param) {
    var vertical = param.vertical;
    return vertical ? "block" : "inline-block";
}, _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highgray */ .Z.highgray);
var IconMoreOptions = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreOptions);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 48469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "ProximaNovaRg";\n  width: ',
        ";\n\n  ",
        "\n\n  .ant-select-selector {\n    border: ",
        " !important;\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    height: inherit !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: props.width,
        border: props.border || "1px solid"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-e69d6f89-0"
})(_templateObject1(), function(param) {
    var width = param.width;
    return width;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var border = param.border;
    return border;
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 70524:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RUNNING_TRADE = {
    SEARCH_INPUT: "running-trade-search-input",
    SEARCH_INPUT_CLEAR_BUTTON: "running-trade-search-input-clear-button"
};
var CALENDAR = {
    HEADER_MORE_BUTTON: "calendar-header-more-button",
    ROW_SYMBOL: "calendar-row-symbol"
};
var PROFILE = {
    HEADER_MORE_BUTTON: "profile-header-more-button",
    HEADER_BLOCK_BUTTON: "profile-header-block-button"
};
var CHATROOM = {
    GROUP_MEMBER: "chatroom-group-member",
    SEND_MESSAGE_BUTTON: "chatroom-send-message-button",
    CONFIRM_DELETE_MESSAGE_BUTTON: "chatroom-confirm-delete-message-button",
    CAPSULE_USER_NEW_GROUP: "chatroom-capsule-user-new-group",
    CAPSULE_USER_NEW_GROUP_CLOSE: "chatroom-capsule-user-new-group-close",
    SUGGESTED_USER: "chatroom-suggested-user"
};
var COMPANY = {
    NAVBAR_MORE_MENU: "company-navbar-more-menu",
    WIDGET_CATALOG: "company-widget-catalog",
    WIDGET_CATALOG_ITEM: "company-widget-catalog-item",
    WIDGET_INVESTMENT_MORE_BUTTON: "company-widget-investment-more-button"
};
var NOTIFICATION = {
    TITLE_TEXT: "notification-title-text"
};
var VALUATION = {
    HEADER_TITLE: "valuation-header-title",
    HEADER_MORE_BUTTON: "valuation-header-more-button"
};
var NAVIGATION = {
    MORE_MENU_BUTTON: "navigation-more-menu-button"
};
var GLOSSARY = {
    SEARCH_SUGGESTION: "glossary-search-suggestion"
};
var SHARE_POST = {
    CHECKBOX: "share-post-checkbox",
    SEND_BUTTON: "share-post-send-button"
};
var STREAM_POST = {
    CONFIRM_DELETE_BUTTON: "stream-post-confirm-delete-button",
    CONFIRM_CANCEL_BUTTON: "stream-post-confirm-cancel-button"
};
var EARNINGS = {
    SEARCH_SYMBOL_INPUT: "earnings-search-symbol-input",
    SEARCH_SYMBOL_BUTTON: "earnings-search-symbol-button",
    TABLE_ROW_SYMBOL: "earnings-table-row-symbol"
};
var FINANCIALS = {
    TABLE_TITLE_TEXT: "financials-table-title-text",
    TABLE_QUARTER_TEXT: "financials-table-quarter-text",
    TABLE_INCOME_TEXT: "financials-table-income-text"
};
var SCREENER = {
    DELETE_RULES_BUTTON: "screener-delete-rules-button",
    CLOSE_POPUP_BUTTON: "screener-close-popup-button",
    STOCK_SEARCH_INPUT: "screener-stock-search-input"
};
var LANDING = {
    REGISTER_BUTTON: "landing-register-button",
    LOGIN_BUTTON: "landing-login-button"
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    RUNNING_TRADE: RUNNING_TRADE,
    CALENDAR: CALENDAR,
    PROFILE: PROFILE,
    CHATROOM: CHATROOM,
    COMPANY: COMPANY,
    NOTIFICATION: NOTIFICATION,
    VALUATION: VALUATION,
    NAVIGATION: NAVIGATION,
    GLOSSARY: GLOSSARY,
    SHARE_POST: SHARE_POST,
    STREAM_POST: STREAM_POST,
    EARNINGS: EARNINGS,
    FINANCIALS: FINANCIALS,
    SCREENER: SCREENER,
    LANDING: LANDING
});


/***/ }),

/***/ 44252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BP": function() { return /* binding */ REGISTRATION_DATA; },
/* harmony export */   "Nv": function() { return /* binding */ REFRESH_TOKEN_KEY_EXP; },
/* harmony export */   "Wx": function() { return /* binding */ ACCESS_TOKEN_KEY; },
/* harmony export */   "ns": function() { return /* binding */ ACCESS_USER_KEY; },
/* harmony export */   "w4": function() { return /* binding */ REFRESH_TOKEN_KEY; },
/* harmony export */   "z0": function() { return /* binding */ ACCESS_TOKEN_KEY_EXP; }
/* harmony export */ });
var ACCESS_TOKEN_KEY = "at";
var ACCESS_TOKEN_KEY_EXP = "ate";
var REFRESH_TOKEN_KEY = "ar";
var REFRESH_TOKEN_KEY_EXP = "are";
var ACCESS_USER_KEY = "au";
var REGISTRATION_DATA = "registerData";


/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);

function useScrollChat() {
    var highlightChat = function(id) {
        var bubbleElement = document.getElementById("".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id));
        bubbleElement.classList.add("chat-highlight");
        setTimeout(function() {
            bubbleElement.classList.remove("chat-highlight");
        }, 3000);
    };
    var scrollToBottom = function() {
        setTimeout(function() {
            var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
            if (contentElement) {
                contentElement.scrollTo({
                    top: contentElement.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    };
    var scrollToChatBubble = function(id) {
        var bubbleId = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id);
        var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
        var bubbleElement = document.getElementById(bubbleId);
        if (bubbleElement) {
            contentElement.scrollTo({
                top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
                behavior: "smooth"
            });
            highlightChat(id);
        } else {
            contentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setTimeout(function() {
                scrollToChatBubble(id);
            }, 500);
        }
    };
    return {
        scrollToBottom: scrollToBottom,
        scrollToChatBubble: scrollToChatBubble,
        highlightChat: highlightChat
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useScrollChat);


/***/ }),

/***/ 37220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetReferralInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89561);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);





var useGetReferralInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return {
        isLoading: false,
        fetchCommunityInfo: function fetchCommunityInfo() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var remisierUI, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            remisierUI = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("remisier");
                            if (!remisierUI) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            // If remisier UI is not exists, then we fetch from API
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,lib_api_community__WEBPACK_IMPORTED_MODULE_1__/* .getReferralInfo */ .Qu)();
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("failed to get community info");
                        case 10:
                            data = response.data.data;
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue("remisier", {
                                isLeader: data.is_leader,
                                isCommunityAccessGranted: data.enabled || data.is_leader
                            });
                            set({
                                isLoading: false
                            });
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 60602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ AVATAR_SIZE; },
/* harmony export */   "Rm": function() { return /* binding */ ONBOARDING_MAX_STEP; },
/* harmony export */   "Wo": function() { return /* binding */ ONBOARDING_REQUEST_FILTER; }
/* harmony export */ });
var ONBOARDING_MAX_STEP = 4;
var AVATAR_SIZE = {
    BIG: "BIG",
    SMALL: "SMALL",
    PORTRAIT: "PORTRAIT"
};
// DISCOVER PEOPLE
var ONBOARDING_USER_SUGGEST_LIMIT = 30;
var ONBOARDING_USER_SUGGEST_PAGE = 1;
var ONBOARDING_USER_SUGGEST_FILTER = "FILTER_ONBOARDING";
var ONBOARDING_REQUEST_FILTER = {
    limit: ONBOARDING_USER_SUGGEST_LIMIT,
    page: ONBOARDING_USER_SUGGEST_PAGE,
    filter: ONBOARDING_USER_SUGGEST_FILTER
};



/***/ }),

/***/ 51346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ localStorageOrderbookHandler; },
/* harmony export */   "M6": function() { return /* binding */ transformNewOrderbookListToExisting; },
/* harmony export */   "g8": function() { return /* binding */ memoizeChild; }
/* harmony export */ });
/* unused harmony export getErrorMessage */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var localStorageOrderbookHandler = {
    get: function() {
        var orderbookName = localStorage.getItem("orderbooklistName");
        var orderbookID = localStorage.getItem("orderbooklistID");
        return {
            orderbookName: orderbookName,
            orderbookID: orderbookID
        };
    },
    set: function(orderbookName, orderbookID) {
        localStorage.setItem("orderbooklistID", orderbookID);
        localStorage.setItem("orderbooklistName", orderbookName);
    },
    remove: function() {
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
};
var getErrorMessage = function(error) {
    var ref;
    var err = _instanceof(error, Error) ? (error === null || error === void 0 ? void 0 : (ref = error.cause) === null || ref === void 0 ? void 0 : ref.message) || error.message : String(error);
    return err;
};
var memoizeChild = function(component) {
    var circular = function() {
        var seen = new WeakSet();
        return function(key, value) {
            if (key.startsWith("_")) return; // Don't compare React's internal props.
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            // eslint-disable-next-line consistent-return
            return value;
        };
    };
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(component, function(prevProps, nextProps) {
        var prev = JSON.stringify(prevProps, circular());
        var next = JSON.stringify(nextProps, circular());
        return prev === next;
    });
};
var transformNewOrderbookListToExisting = function(newResponse) {
    var tradeable = newResponse.tradable ? 1 : 0;
    var bidObject = {};
    var offerObject = {};
    newResponse.bid.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        bidObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        bidObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        bidObject[valueNameKey] = value.volume;
    });
    newResponse.offer.forEach(function(value, index) {
        var priceNameKey = "price".concat(index + 1);
        offerObject[priceNameKey] = value.price;
        var queNumNameKey = "que_num".concat(index + 1);
        offerObject[queNumNameKey] = value.que_num;
        var valueNameKey = "volume".concat(index + 1);
        offerObject[valueNameKey] = value.volume;
    });
    return {
        id: newResponse.id,
        symbol: newResponse.symbol,
        symbol_2: newResponse.symbol,
        symbol_3: newResponse.symbol,
        name: newResponse.name,
        status: newResponse.status,
        lastprice: newResponse.lastprice,
        previous: newResponse.previous,
        change: newResponse.change,
        percentage_change: newResponse.percentage_change,
        open: newResponse.open,
        high: newResponse.high,
        low: newResponse.low,
        close: newResponse.close,
        volume: newResponse.volume,
        value: newResponse.value,
        average: newResponse.average,
        bid: bidObject,
        offer: offerObject,
        frequency: newResponse.frequency,
        fbuy: newResponse.fbuy,
        fsell: newResponse.fsell,
        fnet: newResponse.fnet,
        fpercent: newResponse.fpercent,
        tradeable: tradeable,
        notation: newResponse.notation,
        uma: newResponse.uma,
        GUID: null,
        is_foreignbs_exist: newResponse.has_foreign_bs,
        exchange: newResponse.exchange,
        country: null,
        foreign: null,
        domestic: null,
        up: null,
        down: null,
        unchanged: null,
        iepiev: newResponse.iepiev,
        ara: newResponse.ara,
        arb: newResponse.arb,
        company_type: newResponse.company_type,
        corp_action: newResponse.corp_action,
        market_data: newResponse.market_data,
        auto_reject_estimation: newResponse.auto_reject_estimation
    };
};


/***/ }),

/***/ 16943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _store_usePage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31837);
/* harmony import */ var _Paywall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75850);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67857);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35921);






function PaywallWrapper(param) {
    var children = param.children, feature = param.feature, isFlexible = param.isFlexible, isWidget = param.isWidget;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isReady = ref[0], setReady = ref[1];
    var ref1 = (0,_store_usePage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        featureKey: feature
    }), isPro = ref1.isPro, isLoading = ref1.isLoading, isRenewal = ref1.isRenewal;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setReady(true);
    }, []);
    if (isLoading || !isReady) {
        return null;
    }
    if (isPro) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PaywallPageWrapper */ .qh, {
        isFlexible: isFlexible,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paywall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            source: _analytics__WEBPACK_IMPORTED_MODULE_4__/* .PageAnalytics */ .oF[feature],
            isRenewal: isRenewal,
            isWidget: isWidget,
            height: "272px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaywallWrapper);


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp10 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 31837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60374);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92182);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5072);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11298);





function usePage(param) {
    var featureKey = param.featureKey, _pauseCounter = param.pauseCounter, pauseCounter = _pauseCounter === void 0 ? false : _pauseCounter;
    var ref = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(state) {
        return {
            isPro: state.page.isPro,
            isLoading: state.page.isLoading,
            isRenewal: state.page.isRenewal,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), isPro = ref.isPro, isLoading = ref.isLoading, isRenewal = ref.isRenewal, getStatus = ref.getStatus, addCounter = ref.addCounter;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var KEY = featureKey.toUpperCase();
        var featureName = _constants__WEBPACK_IMPORTED_MODULE_3__/* .PaywallFeatureEnum */ .qU[KEY];
        if (!featureName) return;
        if (!pauseCounter) addCounter({
            feature: featureName
        });
        getStatus({
            key: _types__WEBPACK_IMPORTED_MODULE_2__/* .SectionEnum.page */ .P.page,
            feature: featureName
        });
    }, [
        featureKey,
        pauseCounter
    ]);
    return {
        isPro: isPro,
        isLoading: isLoading,
        isRenewal: isRenewal
    };
};


/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 21455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TradingContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var TradingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    tradingStore: null
});
/* harmony default export */ __webpack_exports__["Z"] = (TradingContext);


/***/ }),

/***/ 207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ provider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/transaction/store.ts



var initialState = {
    openModal: "",
    symbol: null,
    orderType: null,
    openFromWidget: false
};
var tradingStore = function() {
    return (0,esm/* default */.ZP)(function(set) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
            setModal: function(modal, payload) {
                set((0,_object_spread/* default */.Z)({
                    openModal: modal
                }, payload));
            },
            resetModal: function() {
                set(initialState);
            },
            setSymbol: function(symbol) {
                set({
                    symbol: symbol
                });
            },
            setOrderType: function(type) {
                set({
                    orderType: type
                });
            },
            setOpenFromWidget: function(open) {
                set({
                    openFromWidget: open
                });
            },
            setAutoOrderId: function(autoOrderId) {
                set({
                    autoOrderId: autoOrderId
                });
            }
        });
    });
};
/* harmony default export */ var store = (tradingStore);

// EXTERNAL MODULE: ./src/features/transaction/context.tsx
var context = __webpack_require__(21455);
;// CONCATENATED MODULE: ./src/features/transaction/provider.tsx




var TradingContextProvider = function(param) {
    var children = param.children;
    var formValuesContext = (0,react.useMemo)(function() {
        return {
            tradingStore: store()
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: formValuesContext,
        children: children
    });
};
/* harmony default export */ var provider = (TradingContextProvider);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 53120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/features/onboarding/constants.ts
var constants = __webpack_require__(60602);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/hooks/useOnBoarding.ts




function useOnBoarding() {
    var ref = (0,react.useState)(Infinity), onboardingProgress = ref[0], setOnboardingProgress = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var progress = dataProfile.onboarding, statusOnboarding = dataProfile.onboarding_done;
    (0,react.useEffect)(function() {
        // redirect only if data profile is available
        if (dataProfile.id && statusOnboarding == 0 && progress <= constants/* ONBOARDING_MAX_STEP */.Rm) {
            setOnboardingProgress(progress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        progress,
        statusOnboarding,
        dataProfile
    ]);
    return {
        onboardingProgress: onboardingProgress
    };
}
/* harmony default export */ var hooks_useOnBoarding = (useOnBoarding);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var slice = __webpack_require__(40927);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Notification/index.tsx + 1 modules
var Notification = __webpack_require__(77667);
// EXTERNAL MODULE: ./src/features/chat/MainContent/useScrollChat.ts
var useScrollChat = __webpack_require__(4881);
// EXTERNAL MODULE: ./src/features/chat/store/index.ts + 7 modules
var store = __webpack_require__(77284);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/utils/socketSocial.ts



var transformToNotifMessage = function(rawText, type) {
    var text = sanitize_html_default()(rawText);
    var _obj;
    var attachmentContentMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO */.G0.ATTACHMENT_TYPE_PHOTO, " *IMAGE*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF */.G0.ATTACHMENT_TYPE_GIF, " *GIF*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST */.G0.ATTACHMENT_TYPE_POST, " *POST*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER */.G0.ATTACHMENT_TYPE_STICKER, " *STICKER*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF */.G0.ATTACHMENT_TYPE_PDF, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE */.G0.ATTACHMENT_TYPE_SHARETRADE, ""), _obj);
    text += attachmentContentMapper[type];
    return text;
};


;// CONCATENATED MODULE: ./src/hooks/useChatListenerWsSocialV2.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 



















var checkMessageDuplicated = function(messages, newRoomId, lastMessageId) {
    if (messages[newRoomId]) {
        var ref;
        return (ref = messages[newRoomId]) === null || ref === void 0 ? void 0 : ref.messages.some(function(chat) {
            return chat.id === lastMessageId;
        });
    }
    return false;
};
var checkMissingObjectText = function(body) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var chatMessageV1 = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.message;
    var valueText = (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref4 = chatMessageV1.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.conversation) === null || ref5 === void 0 ? void 0 : ref5.text) ? chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref6 = chatMessageV1.body) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.conversation) === null || ref7 === void 0 ? void 0 : ref7.text : "";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1), {
        text: valueText,
        body: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1.body), {
            conversation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref8 = chatMessageV1.body) === null || ref8 === void 0 ? void 0 : ref8.conversation), {
                text: valueText,
                attachmentType: (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref9 = chatMessageV1.body) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.conversation) === null || ref10 === void 0 ? void 0 : ref10.attachmentType) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED
            })
        })
    });
};
var handleRefreshGroupRoom = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
        var hasRoomDetail, ref, groupId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return store/* roomDetailStore.getState */.e.getState().refreshGroupRoomDetail(chatId);
                case 2:
                    hasRoomDetail = _ctx.sent;
                    if (!hasRoomDetail) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    groupId = (ref = store/* roomDetailStore.getState */.e.getState().group[chatId]) === null || ref === void 0 ? void 0 : ref.id;
                    _ctx.next = 8;
                    return store/* groupMemberStore.getState */.VY.getState().fetchGroupMember(groupId, 0);
                case 8:
                    chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleRefreshGroupRoom(chatId) {
        return _ref.apply(this, arguments);
    };
}();
function useChatListenerWsSocialV2() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeRoomId = (0,es/* useSelector */.v9)(chat_slice/* selectors */.wl).activeRoomId;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), _notifications = ref.notifications, notif = _notifications.data;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataLoggedInUser = ref1.data;
    var newIncomingChatWsSocialV2 = (0,es/* useSelector */.v9)(WebSocketV2_slice/* chatWsSocialV2Selector */.WM);
    var messages = (0,chat/* default */.Z)(function(store) {
        return store.conversation.messages;
    });
    var defaultRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var invitedRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.invited.list;
    });
    var updateRoomListFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateRoomListFromWS;
    });
    var pushMessage = (0,chat/* default */.Z)(function(store) {
        return store.pushMessage;
    });
    var updateMessageFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateMessageFromWS;
    });
    var scrollToBottom = (0,useScrollChat/* default */.Z)().scrollToBottom;
    var actionChatRoom = function(incomingChat) {
        if (activeRoomId > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var body = incomingChat.body;
            var newMessage = checkMissingObjectText(body);
            var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
            var referenceId = body === null || body === void 0 ? void 0 : (ref4 = body.event) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chatMessage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref7 === void 0 ? void 0 : ref7.referenceId;
            var roomStatus = body === null || body === void 0 ? void 0 : (ref8 = body.event) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chatMessage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref11 === void 0 ? void 0 : ref11.roomStatus;
            newMessage = (0,utils/* snakelizeKeys */.t_)(newMessage);
            newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
            var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newMessage === null || newMessage === void 0 ? void 0 : newMessage.id) : false;
            // Check if the event comes when user leave
            var isStateUnspecified = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_UNSPECIFIED */.Kn.ROOM_STATE_UNSPECIFIED;
            var isDeletedEvent = (newMessage === null || newMessage === void 0 ? void 0 : (ref12 = newMessage.body) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.conversation) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.flag) === null || ref14 === void 0 ? void 0 : ref14.is_deleted) ? newMessage === null || newMessage === void 0 ? void 0 : (ref15 = newMessage.body) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conversation) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.flag) === null || ref17 === void 0 ? void 0 : ref17.is_deleted : false;
            if (!isDuplicated && !isStateUnspecified && !isDeletedEvent) {
                var ref18, ref19, ref20, ref21, ref22;
                var chatId = newRoom.id;
                // push message to state;
                pushMessage({
                    chatId: chatId,
                    message: newMessage,
                    reference_id: referenceId,
                    room_status: roomStatus,
                    room: newRoom
                });
                // scroll to bottom if in current active chat is receive new message
                var isChatPageShowed = router_default().asPath.includes("/chat/".concat(chatId)) || router_default().asPath.includes("/group-chat/".concat(chatId)) || router_default().asPath.includes("/broadcast-chat/".concat(chatId));
                var senderUserData = newMessage === null || newMessage === void 0 ? void 0 : (ref18 = newMessage.body) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.conversation) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.sender) === null || ref20 === void 0 ? void 0 : ref20.user;
                var senderUserName = senderUserData && senderUserData.username ? senderUserData.username : "";
                var isReceiver = senderUserName !== dataLoggedInUser.username;
                if (isChatPageShowed) {
                    var container = document.getElementById("chat-content-container");
                    var currentPos = container.scrollHeight - container.clientHeight - 200;
                    var currentlyScrollingUp = container.scrollTop < currentPos;
                    // when there is incoming message on receiver side, that is currently scrolling up
                    // don't scroll to bottom
                    if (isReceiver && !currentlyScrollingUp || !isReceiver) {
                        scrollToBottom();
                    }
                }
                // Handle event type message from ws in group chat
                // will refresh the room detail and member list
                var isCurrentPage = router_default().asPath.includes("/group-chat/".concat(chatId));
                var isEventMessage = (newMessage === null || newMessage === void 0 ? void 0 : newMessage.body_type) === constant/* MESSAGE_BODY_TYPE.MESSAGE_BODY_TYPE_EVENT */.dn.MESSAGE_BODY_TYPE_EVENT;
                var isNotLeaveEvent = ((newMessage === null || newMessage === void 0 ? void 0 : (ref21 = newMessage.body) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.event) === null || ref22 === void 0 ? void 0 : ref22.text) || "").toLowerCase() !== "you left";
                if (isCurrentPage && isEventMessage && isNotLeaveEvent) {
                    handleRefreshGroupRoom(chatId);
                }
            } else {
                // update message if id has available on convo,
                updateMessageFromWS({
                    chatId: newRoom.id,
                    messageId: newMessage.id,
                    message: newMessage
                });
            }
        }
    };
    var actionRoomList = function(incomingChat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var body = incomingChat.body;
        var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatRoomInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
        newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
        var messageId = newRoom === null || newRoom === void 0 ? void 0 : (ref4 = newRoom.last_message) === null || ref4 === void 0 ? void 0 : ref4.id;
        var isAccepted = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_ACCEPTED */.Kn.ROOM_STATE_ACCEPTED;
        var isPersonalChat = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL;
        var isBroadcast = // TODO: remove 3
        // While waiting for proto definition encoding is done,
        // we use number 3 as broadcast type,
        // Currently, BE is sending 3 instead of ROOM_TYPE_BROADCAST
        (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.BROADCAST */._2.BROADCAST;
        var roomList = isAccepted ? defaultRooms : invitedRooms;
        var lastMessage = (0,immer_esm/* default */.ZP)(newRoom === null || newRoom === void 0 ? void 0 : newRoom.last_message, function(draft) {
            var ref, ref1, ref2, ref3;
            draft.text = (newRoom === null || newRoom === void 0 ? void 0 : (ref = newRoom.last_message) === null || ref === void 0 ? void 0 : ref.text) ? newRoom.last_message.text : "";
            draft.sender_username = ((ref1 = newRoom.last_message) === null || ref1 === void 0 ? void 0 : ref1.sender_username) || "";
            // Replace last message if user delete their own latest chat
            if ((newRoom === null || newRoom === void 0 ? void 0 : (ref2 = newRoom.last_message) === null || ref2 === void 0 ? void 0 : ref2.text) === "This message was deleted" && ((ref3 = newRoom.last_message) === null || ref3 === void 0 ? void 0 : ref3.sender_username) === dataLoggedInUser.username) {
                draft.text = "You deleted this message";
                draft.placeholder_mask.masked_text = "You deleted this message";
            }
        });
        // ws social not send sender userId
        var senderUserName = lastMessage.sender_username;
        var isReceiver = senderUserName !== dataLoggedInUser.username;
        var isEventMessage = isPersonalChat || isBroadcast ? false : !senderUserName;
        var roomIdx = roomList.findIndex(function(item) {
            return item.id === (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id);
        });
        var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newRoom === null || newRoom === void 0 ? void 0 : (ref5 = newRoom.last_message) === null || ref5 === void 0 ? void 0 : ref5.id) : false;
        // existing chatroom
        if (roomIdx > -1) {
            var ref8, ref9, ref10;
            var roomInfo = isPersonalChat || isBroadcast ? roomList[roomIdx].info : (0,_object_spread/* default */.Z)({
                avatar_url: (newRoom === null || newRoom === void 0 ? void 0 : (ref8 = newRoom.info) === null || ref8 === void 0 ? void 0 : ref8.avatar_url) || ""
            }, newRoom === null || newRoom === void 0 ? void 0 : newRoom.info);
            var updateLastMessage = isDuplicated ? ((ref10 = (ref9 = messages[newRoom === null || newRoom === void 0 ? void 0 : newRoom.id]) === null || ref9 === void 0 ? void 0 : ref9.messages[0]) === null || ref10 === void 0 ? void 0 : ref10.id) === messageId : true;
            lastMessage = updateLastMessage ? lastMessage : roomList[roomIdx].last_message;
            var unreadCount = roomList[roomIdx].unread_count || 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount = roomList[roomIdx].unread_count + 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomList[roomIdx]), {
                last_message: lastMessage,
                info: roomInfo,
                unread_count: unreadCount,
                status: newRoom === null || newRoom === void 0 ? void 0 : newRoom.status,
                isBroadcast: isBroadcast
            });
        } else {
            var unreadCount1 = 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount1 += 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newRoom), {
                unread_count: unreadCount1,
                isBroadcast: isBroadcast
            });
        }
        // wont update the room list if the event is us leaving
        if ((newRoom === null || newRoom === void 0 ? void 0 : (ref6 = newRoom.lastMessage) === null || ref6 === void 0 ? void 0 : ref6.text) !== "You left") {
            updateRoomListFromWS(newRoom);
        }
        // Show Left Bottom Push Notification
        var isInvitedChat = newRoom.state === constant/* StateChatList.ROOM_STATE_INVITED */.Kn.ROOM_STATE_INVITED;
        var isMuted = newRoom.status.isMuted || false;
        var getCurrentIncomingNotifType = (ref7 = (0,utils/* getNotifType */.K5)(newRoom)) === null || ref7 === void 0 ? void 0 : ref7.notifType;
        var incomingMessageDataNotifSetting = notif.find(function(notifGroup) {
            return notifGroup.group === constant/* NOTIF_GROUP_CHAT */.wS;
        }).notifications.find(function(notifItem) {
            return notifItem.type === getCurrentIncomingNotifType;
        });
        if (isReceiver && !isMuted && incomingMessageDataNotifSetting) {
            var isDesktopNotificationTurnOn = incomingMessageDataNotifSetting.settings.find(function(setting) {
                return setting.key === constant/* NOTIF_SETTING_KEY_DN */.gK;
            }).value;
            if (isDesktopNotificationTurnOn) {
                var ref11, ref12, ref13, ref14, ref15, ref16;
                var groupChatName = (newRoom === null || newRoom === void 0 ? void 0 : (ref11 = newRoom.info) === null || ref11 === void 0 ? void 0 : ref11.name) || "Group Chat";
                var usernameAtGroup = senderUserName ? "".concat(senderUserName, " @") : "";
                var notifTitle = newRoom.type === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL ? senderUserName : "".concat(usernameAtGroup, " ").concat(groupChatName);
                var lastMessageType = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED;
                (0,Notification/* showChatNotification */.Ac)({
                    title: notifTitle,
                    description: transformToNotifMessage(lastMessage.text, lastMessageType),
                    isDeactivate: (newRoom === null || newRoom === void 0 ? void 0 : (ref12 = newRoom.attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.personal) === null || ref13 === void 0 ? void 0 : ref13.is_deactivated) || false,
                    name: (newRoom === null || newRoom === void 0 ? void 0 : (ref14 = newRoom.info) === null || ref14 === void 0 ? void 0 : ref14.name) || "",
                    shortName: (newRoom === null || newRoom === void 0 ? void 0 : (ref15 = newRoom.info) === null || ref15 === void 0 ? void 0 : ref15.shortened_name) || "",
                    type: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) || constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL,
                    avatar: (newRoom === null || newRoom === void 0 ? void 0 : (ref16 = newRoom.info) === null || ref16 === void 0 ? void 0 : ref16.avatar_url) || "",
                    id: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id) || 0,
                    key: "in-app-notification-".concat(newRoom === null || newRoom === void 0 ? void 0 : newRoom.id),
                    isPersonalChat: isPersonalChat,
                    isInvitedChat: isInvitedChat,
                    onClose: function() {
                        dispatch(WebSocketV2_slice/* default.actions.clearChat */.ZP.actions.clearChat());
                    }
                });
            }
        }
    };
    var _obj;
    var actionEventType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_MESSAGE */.aw.TYPE_CHAT_MESSAGE, function(incomingChat) {
        return actionChatRoom(incomingChat);
    }), (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_ROOM_INFO */.aw.TYPE_CHAT_ROOM_INFO, function(incomingChat) {
        return actionRoomList(incomingChat);
    }), _obj);
    var actionTypeBroadCast = function(incomingChat) {
        var ref, ref1;
        var incomingBodyEventType = incomingChat === null || incomingChat === void 0 ? void 0 : (ref = incomingChat.body) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.type;
        return actionEventType[incomingBodyEventType] && actionEventType[incomingBodyEventType](incomingChat);
    };
    var chatListener = function(incomingChat) {
        if (incomingChat) {
            /* Additional information

        1. SEND MESSAGE
        When user send message to group room or personal room,
        ws will send event new messages as a sender so after
        that, we will update the slice conversations.

        2. OLD WEBSOCKET
        There is 3 version of WS, the old (M) that have been
        deprecated, the new (M2) and the latest one (M3).
        In this listener we will only use M3 as our WS event.
        To prevent doubled event sented to us, we use message.id
        as identifier to check if the message has been save in
        redux/slice or not.

        3. BODY TYPE OF EVENT
        Personal room and group room message now have same
        body payload. We dont need to transform the body.

       */ actionTypeBroadCast(incomingChat);
        }
    };
    (0,react.useEffect)(function() {
        if (!isUserLogin) {
            return;
        }
        // After check the behaviour, it more safe to use
        // synchronously process instead of asynchronous
        // when receive double events from ws
        // @ts-ignore
        chatListener(newIncomingChatWsSocialV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newIncomingChatWsSocialV2,
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ var hooks_useChatListenerWsSocialV2 = (useChatListenerWsSocialV2);

// EXTERNAL MODULE: ./src/features/community/hooks/useGetReferralInfo.ts
var useGetReferralInfo = __webpack_require__(37220);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/MainLayout/styled.ts
var styled = __webpack_require__(92589);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/__tests__/constant.ts
var DATA_CY_MAIN_LAYOUT = "main-layout";

;// CONCATENATED MODULE: ./src/global/MainLayout/index.tsx
/* eslint-disable react/forbid-prop-types */ 










// Local Components








// import webSocketSlice from 'global/WebSocketV2/slice';

// local redux slice


var HeaderWeb = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(4269), __webpack_require__.e(68672), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(82608), __webpack_require__.e(63923), __webpack_require__.e(5214), __webpack_require__.e(50011), __webpack_require__.e(48713)]).then(__webpack_require__.bind(__webpack_require__, 48713));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48713)
            ];
        }
    },
    ssr: false
});
var HeaderMobile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2678), __webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(42298), __webpack_require__.e(4269), __webpack_require__.e(68672), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(82608), __webpack_require__.e(63923), __webpack_require__.e(5214), __webpack_require__.e(12127)]).then(__webpack_require__.bind(__webpack_require__, 12127));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12127)
            ];
        }
    },
    ssr: false
});
var SideWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(76750), __webpack_require__.e(35851), __webpack_require__.e(21574), __webpack_require__.e(46312), __webpack_require__.e(74749), __webpack_require__.e(13198), __webpack_require__.e(52189)]).then(__webpack_require__.bind(__webpack_require__, 69908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69908)
            ];
        }
    },
    ssr: false
});
var OnBoarding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(29306), __webpack_require__.e(7475), __webpack_require__.e(54392), __webpack_require__.e(74645), __webpack_require__.e(76352), __webpack_require__.e(91086)]).then(__webpack_require__.bind(__webpack_require__, 91086));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91086)
            ];
        }
    },
    ssr: false
});
var ModalTransactionSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(76750), __webpack_require__.e(42298), __webpack_require__.e(35851), __webpack_require__.e(70735), __webpack_require__.e(24513), __webpack_require__.e(67555), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(48761), __webpack_require__.e(25127), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(36902), __webpack_require__.e(91154), __webpack_require__.e(91727), __webpack_require__.e(15068), __webpack_require__.e(31532), __webpack_require__.e(82608), __webpack_require__.e(42603), __webpack_require__.e(19098), __webpack_require__.e(32172), __webpack_require__.e(84637), __webpack_require__.e(31388), __webpack_require__.e(82825)]).then(__webpack_require__.bind(__webpack_require__, 39337));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39337)
            ];
        }
    },
    ssr: false
});
var ModalAuthSecurities = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(42298), __webpack_require__.e(61980), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(91154), __webpack_require__.e(38305), __webpack_require__.e(50713), __webpack_require__.e(71684)]).then(__webpack_require__.bind(__webpack_require__, 62366));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62366)
            ];
        }
    },
    ssr: false
});
var ModalShareTradeManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(76750), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(35851), __webpack_require__.e(70735), __webpack_require__.e(67555), __webpack_require__.e(98294), __webpack_require__.e(76219), __webpack_require__.e(85925), __webpack_require__.e(9087), __webpack_require__.e(75413), __webpack_require__.e(36902), __webpack_require__.e(686), __webpack_require__.e(68106), __webpack_require__.e(20242), __webpack_require__.e(79607)]).then(__webpack_require__.bind(__webpack_require__, 61785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61785)
            ];
        }
    },
    ssr: false
});
var GlobalModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(58928), __webpack_require__.e(92077), __webpack_require__.e(79931), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(35851), __webpack_require__.e(24513), __webpack_require__.e(1013), __webpack_require__.e(38052), __webpack_require__.e(22939), __webpack_require__.e(75413), __webpack_require__.e(74673), __webpack_require__.e(36902), __webpack_require__.e(19098), __webpack_require__.e(61442), __webpack_require__.e(50991), __webpack_require__.e(39689), __webpack_require__.e(42411), __webpack_require__.e(6655)]).then(__webpack_require__.bind(__webpack_require__, 9159));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9159)
            ];
        }
    },
    ssr: false
});
var ModalBonds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(76750), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(24513), __webpack_require__.e(98294), __webpack_require__.e(61980), __webpack_require__.e(48761), __webpack_require__.e(36385), __webpack_require__.e(27173), __webpack_require__.e(54392), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(91154), __webpack_require__.e(91727), __webpack_require__.e(82608), __webpack_require__.e(42603), __webpack_require__.e(29184), __webpack_require__.e(92120), __webpack_require__.e(35638)]).then(__webpack_require__.bind(__webpack_require__, 14426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14426)
            ];
        }
    },
    ssr: false
});
var ModalUnavailable = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(12438)]).then(__webpack_require__.bind(__webpack_require__, 15994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15994)
            ];
        }
    },
    ssr: false
});
var ModalErrorManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(51906), __webpack_require__.e(33598)]).then(__webpack_require__.bind(__webpack_require__, 51906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51906)
            ];
        }
    },
    ssr: false
});
var MultiPortoModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(88069), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(98294), __webpack_require__.e(68606), __webpack_require__.e(44975)]).then(__webpack_require__.bind(__webpack_require__, 44975));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44975)
            ];
        }
    },
    ssr: false
});
var StreamErrorModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(61980), __webpack_require__.e(5633), __webpack_require__.e(38305), __webpack_require__.e(91011)]).then(__webpack_require__.bind(__webpack_require__, 91011));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91011)
            ];
        }
    },
    ssr: false
});
var DatafeedModalManager = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(33070), __webpack_require__.e(66158)]).then(__webpack_require__.bind(__webpack_require__, 44992));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44992)
            ];
        }
    },
    ssr: false
});
function MainLayout(param) {
    var children = param.children, isFlexibleWidth = param.isFlexibleWidth, maxWidth = param.maxWidth, background = param.background, width = param.width, _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    // Library hooks
    var dispatch = (0,es/* useDispatch */.I0)();
    var breakpoints = (0,useBreakpoint/* default */.Z)();
    // Zustand store
    var ref = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return {
            fetchChatUnreadCount: s.fetchUnreadCount,
            isChatUnreadCountReset: s.isReset
        };
    }), fetchChatUnreadCount = ref.fetchChatUnreadCount, isChatUnreadCountReset = ref.isChatUnreadCountReset;
    var fetchCommunityInfo = (0,useGetReferralInfo/* useGetReferralInfo */.s)(function(s) {
        return s.fetchCommunityInfo;
    });
    // Redux store
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref1 = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref1.isSideWidgetOpen, isHeaderMinimized = ref1.isHeaderMinimized, isMarketOpen = ref1.isMarketOpen;
    // Custom hooks
    var onboardingProgress = hooks_useOnBoarding().onboardingProgress;
    (0,useProfileData/* default */.Z)();
    (0,useNotificationListener/* default */.Z)(isLoggedIn);
    hooks_useChatListenerWsSocialV2(isLoggedIn);
    // Reactive variable
    var isShowOnboarding = onboardingProgress < constants/* ONBOARDING_MAX_STEP */.Rm;
    var props = width ? {
        style: {
            width: width
        }
    } : {};
    (0,react.useEffect)(function() {
        if (!isLoggedIn) {
            return;
        }
        // During route changes or reload:
        // re-fetch unread chat if state is haven't reset
        // or clear chat data if state have reset
        // if (!isChatUnreadCountReset) {
        //   fetchChatUnreadCount();
        // } else {
        //   dispatch(webSocketSlice.actions.clearChat());
        // }
        fetchChatUnreadCount();
        fetchCommunityInfo();
        dispatch(slice/* effects.getNotifications */.Sz.getNotifications());
    }, [
        isLoggedIn
    ]);
    // React render
    if (isShowOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoarding, {
            progress: onboardingProgress
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-cy": DATA_CY_MAIN_LAYOUT,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WrapperMainContent */.UI, {
                            isSideWidgetOpen: isSideWidgetOpen,
                            isMarketOpen: isMarketOpen,
                            children: [
                                breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWeb, {
                                    isSideWidgetOpen: isSideWidgetOpen,
                                    isMarketOpen: isMarketOpen,
                                    isHeaderMinimized: isHeaderMinimized
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Wrapper */.im, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    background: background,
                                    isSideWidgetOpen: isSideWidgetOpen
                                }, props), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* default */.ZP, {
                                        id: "main-container",
                                        isFlexibleWidth: isFlexibleWidth,
                                        maxWidth: maxWidth,
                                        isSideWidgetOpen: isSideWidgetOpen,
                                        fullPage: fullPage,
                                        isMarketOpen: isMarketOpen,
                                        children: children
                                    })
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAuthSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTransactionSecurities, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTradeManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiPortoModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamErrorModalManager, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedModalManager, {})
            ]
        })
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    isFlexibleWidth: (prop_types_default()).bool,
    maxWidth: (prop_types_default()).number,
    background: (prop_types_default()).string,
    width: (prop_types_default()).any
};
MainLayout.defaultProps = {
    isFlexibleWidth: false,
    maxWidth: undefined,
    background: "transparent",
    width: undefined
};
/* harmony default export */ var global_MainLayout = (MainLayout);


/***/ }),

/***/ 73580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59148);



var initialState = {
    errorCode: null,
    errorMessage: "",
    errorType: ""
};
var mainLayoutStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setErrorCode: function(code) {
            var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
            set({
                errorCode: code,
                errorMessage: message,
                errorType: type
            });
        },
        resetErrorCode: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (mainLayoutStore);


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ SIDE_WIDGET_OPENED_WIDTH; },
/* harmony export */   "U9": function() { return /* binding */ SIDE_WIDGET_CONTENT_WIDTH; },
/* harmony export */   "UI": function() { return /* binding */ WrapperMainContent; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zX": function() { return /* binding */ SIDE_WIDGET_TOOLBAR_WIDTH; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74575);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        width: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px auto 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  max-width: ",
        ";\n\n  &.chat-expanded {\n    margin: 0 auto 0 auto !important;\n    padding: 0 !important;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    margin: 100px auto 0;\n    max-width: ",
        ";\n\n    &.chat-expanded {\n      margin: 0px auto 0 auto !important;\n      padding: 20px 37px 0 0 !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n    &:has(#academy-iframe) {\n      position: absolute !important;\n      left: 0;\n      padding-bottom: 0;\n      width: 100% !important;\n      max-width: ",
        ";\n      margin: ",
        ";\n    }\n  }\n\n  @media screen and (min-width: 1500px) {\n    margin: 100px auto 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// TODO: Update device dimension to DS
var laptopM = "(min-width:1081px)";
var device = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    laptopM: laptopM
});
var SIDE_WIDGET_CONTENT_WIDTH = "330px";
var SIDE_WIDGET_TOOLBAR_WIDTH = "35px";
var SIDE_WIDGET_OPENED_WIDTH = "365px";
// prettier-ignore
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].main.withConfig */ .ZP.main.withConfig({
    componentId: "sc-98894054-0"
})(_templateObject1(), function(props) {
    return props.fullPage ? "0" : "20px 0";
}, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(props) {
    return props.isFlexibleWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), device.tablet, props.isMarketOpen ? "calc(100% - 60px)" : "calc(100% - 100px)");
}, device.tablet, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "660px";
}, device.laptopM, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "unset";
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px) !important";
        }
        return "calc(100% - 365px) !important";
    }();
}, function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen;
    return isSideWidgetOpen && "auto !important";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-1"
})(_templateObject2(), function(props) {
    return props.background ? props.background : "transparent";
});
var WrapperMainContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-98894054-2"
})(_templateObject3(), function(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isMarketOpen = param.isMarketOpen;
    return function() {
        if (!isSideWidgetOpen) {
            return "calc(100% - ".concat(SIDE_WIDGET_TOOLBAR_WIDTH, ") ");
        }
        if (!isMarketOpen) {
            return "calc(100% - 425px)";
        }
        return "calc(100% - 365px)";
    }();
});
/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 91364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2497);
/* harmony import */ var global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23985);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77667);
/* harmony import */ var lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89790);





var PRICE_ALERT_KEY = "price-alert";
function useNotificationListener() {
    var isUserLogin = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var unread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.unread;
    });
    var setUnread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.setUnread;
    });
    var notification = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* .notifWsSelector */ .i9);
    var notificationListener = function() {
        var notif = notification[notification.length - 1];
        // Update unread notification
        setUnread(unread + 1);
        var onClose = function() {
            return dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.resetNotification */ .ZP.actions.resetNotification());
        };
        // Show notification on left bottom side
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (0,global_Notification__WEBPACK_IMPORTED_MODULE_3__/* .showGeneralNotification */ .uw)(notif, onClose);
    };
    var getPriceAlertFromLocalStorage = function() {
        var alertRaw = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(PRICE_ALERT_KEY);
        if (alertRaw) {
            try {
                return JSON.parse(alertRaw);
            } catch (e) {
                return false;
            }
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        if ((notification === null || notification === void 0 ? void 0 : notification.length) > 0) {
            notificationListener();
        }
    }, [
        notification === null || notification === void 0 ? void 0 : notification.length,
        isUserLogin
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isUserLogin) return;
        var alert = getPriceAlertFromLocalStorage();
        if (alert) {
            dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setAlert */ .ZP.actions.setAlert(alert));
        }
    }, [
        isUserLogin
    ]);
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNotificationListener);


/***/ }),

/***/ 74786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * Brief description of the function here.
 * @summary save state as previous state for future use (e.g. comparing state)
 * @useCase const [glossaryTerms, setGlossaryTerms] = useState([]);
 * const prevGlossaryTerms = usePreviousState(glossaryTerms);
 * if (prevGlossaryTerms !== glossaryTerms) {
 * do something
 * }
 * @param {any} value - state to be saved as previous state.
 * @returns {any} - previous state
 */ var usePreviousState = function(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePreviousState);


/***/ }),

/***/ 30995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14229);




function useProfileData() {
    // get data from reducer
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // get data from profile
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .selectors */ .wl), dataProfile = ref.data;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // check if profile data is available
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (parsedCookie) {
            var token = parsedCookie.accessToken.token;
            // check if there's token but empty data profile
            if (token && !dataProfile.id) {
                var userAccess = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess();
                // @ts-ignore
                var username = userAccess.username;
                // get user data profile
                // @ts-ignore
                dispatch(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .effects.getUserProfile */ .Sz.getUserProfile(username));
            }
        }
    }, [
        dispatch,
        dataProfile
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useProfileData);


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14229);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ deleteReferral; },
/* harmony export */   "ER": function() { return /* binding */ getReferralStatus; },
/* harmony export */   "H5": function() { return /* binding */ postApplyReferral; },
/* harmony export */   "KT": function() { return /* binding */ getReferralByCode; },
/* harmony export */   "Qu": function() { return /* binding */ getReferralInfo; },
/* harmony export */   "ve": function() { return /* binding */ getReferralMembers; }
/* harmony export */ });
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestWithoutAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var getReferralInfo = function() {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/info"));
};
var getReferralStatus = function() {
    return requestWithoutAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/status"));
};
var getReferralByCode = function(code) {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/").concat(code));
};
var getReferralMembers = function(param) {
    var keyword = param.keyword, status = param.status, startDate = param.startDate, endDate = param.endDate, cursor = param.cursor;
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/affiliate/members"), {
        params: {
            search: keyword !== "" ? keyword : undefined,
            status: status !== "MEMBER_STATUS_UNSPECIFIED" ? status : undefined,
            start_date: startDate,
            end_date: endDate,
            cursor: cursor
        }
    });
};
var postApplyReferral = function(code) {
    return request.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/apply"), {
        code: code
    });
};
var deleteReferral = function() {
    return request.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral"));
};
var communityAPI = {
    getReferralInfo: getReferralInfo,
    getReferralStatus: getReferralStatus,
    getReferralByCode: getReferralByCode,
    getReferralMembers: getReferralMembers,
    postApplyReferral: postApplyReferral,
    deleteReferral: deleteReferral
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (communityAPI)));


/***/ }),

/***/ 89790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useNotificationData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42435);
/* harmony import */ var lib_api_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99368);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);









var useNotificationData = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__/* .immer */ .n)(function(set) {
    return {
        tab: "notification",
        isPopupOpen: false,
        isConvoOpen: false,
        isReading: false,
        isLoading: false,
        isLoadingPrevious: false,
        contents: {
            notification: {
                list: [],
                lastId: null
            },
            mention: {
                list: [],
                lastId: null
            },
            report: {
                list: [],
                lastId: null
            },
            tipping: {
                list: [],
                lastId: null
            }
        },
        unread: 0,
        // UI Reducers
        changeTab: function changeTab(tab) {
            set(function(draft) {
                draft.tab = tab;
            });
        },
        togglePopup: function togglePopup() {
            set(function(draft) {
                draft.isPopupOpen = !draft.isPopupOpen;
            });
        },
        closePopup: function closePopup() {
            set(function(draft) {
                draft.isPopupOpen = false;
            });
        },
        setConvoOpen: function setConvoOpen(id) {
            var isOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            set(function(draft) {
                draft.isConvoOpen = isOpen;
                draft.convoId = id;
            });
        },
        closeConvo: function closeConvo() {
            set(function(draft) {
                draft.isConvoOpen = false;
                draft.convoId = undefined;
            });
        },
        setUnread: function setUnread(count) {
            set(function(draft) {
                draft.unread = count;
            });
        },
        getNotification: // Asynchronous actions
        function getNotification1(tab) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = result;
                                draft.isLoading = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isLoading = false;
                            });
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        getPrevNotification: function getPrevNotification(tab, lastId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // if previous
                            set(function(draft) {
                                draft.isLoadingPrevious = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes, 25, lastId);
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(draft.contents[tab].list).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(result));
                                draft.isLoadingPrevious = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        getUnreadCount: function getUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getUnreadNotificationNumber */ .O7)();
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = result.unread;
                                });
                            }
                            _ctx.next = 15;
                            break;
                        case 14:
                            throw new Error("failed to read notification");
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        markNotifAsRead: function markNotifAsRead() {
            var tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "notification";
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                                draft.isReading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .markAsRead */ .zJ)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 15;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = 0;
                                    draft.isReading = false;
                                    draft.contents[tab].list = draft.contents[tab].list.map(function(item) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                            is_read: true
                                        });
                                    });
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 15:
                            throw new Error("failed to read notification");
                        case 16:
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isReading = false;
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        }
    };
}));


/***/ }),

/***/ 14229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var constants_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44252);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51346);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);





function getToken() {
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return {
            accessToken: {
                token: null,
                expiry: null,
                isValid: null
            },
            refresh: {
                token: null,
                expiry: null,
                isValid: null
            }
        };
    }
    var ls = localStorage;
    // set cookies
    // format date from backend is still in seconds, while
    // JS' date is in miliseconds format, thus multiply the date by 1000
    var accessToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx]) : null;
    var accessTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0]), 10) : null;
    var refreshToken = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4]) : null;
    var refreshTokenExp = ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] ? parseInt((0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(ls[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv]), 10) : null;
    // check expiry
    var currentTime = Date.now();
    var isAccessTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(accessTokenExp, currentTime);
    var isRefreshTokenValid = (0,date_fns_isAfter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(refreshTokenExp, currentTime);
    return {
        accessToken: {
            token: accessToken,
            expiry: accessTokenExp,
            isValid: isAccessTokenValid
        },
        refresh: {
            token: refreshToken,
            expiry: refreshTokenExp,
            isValid: isRefreshTokenValid
        }
    };
}
function saveToken(param) {
    var accessToken = param.accessToken, accessTokenExp = param.accessTokenExp, refreshToken = param.refreshToken, refreshTokenExp = param.refreshTokenExp, accessUser = param.accessUser;
    if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        return;
    }
    if (accessUser) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessTokenExp.toString());
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshToken);
    localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(refreshTokenExp.toString());
}
function updateAccessUser(accessUser) {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(accessUser);
    }
}
function destroyToken() {
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY */ .Wx);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_TOKEN_KEY_EXP */ .z0);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY */ .w4);
        localStorage.removeItem(constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .REFRESH_TOKEN_KEY_EXP */ .Nv);
        localStorage.removeItem("stbx-active-indexwatchlist");
        localStorage.removeItem("stbx-active-watchlist");
        localStorage.removeItem("stbx-active-widget");
        localStorage.removeItem("stbx-active-stream-header");
        localStorage.removeItem("stbx-active-stream");
        localStorage.removeItem("trade-orderbook-show-confirmation");
        localStorage.removeItem("tradeIsLogin");
        localStorage.removeItem("tradingVersion");
        localStorage.removeItem("tradingAccountType");
        localStorage.removeItem("taps");
        localStorage.removeItem("tradingBroker");
        localStorage.removeItem("lastTradingAccountType");
        localStorage.removeItem("register_trading_useractive_sinarmas");
        localStorage.removeItem("register_trading_sinarmas");
        localStorage.removeItem("register_trading_useractive");
        localStorage.removeItem("tradingBrokerList");
        localStorage.removeItem("financials-panel-amount");
        localStorage.removeItem("financials-panel-currency");
        localStorage.removeItem("financials-panel-datatype");
        localStorage.removeItem("financials-panel-lang");
        localStorage.removeItem("financials-panel-ordertype");
        localStorage.removeItem("financials-panel-reportype");
        localStorage.removeItem("financials-panel-rounding-count");
        localStorage.removeItem("financials-panel-rounding-symbol");
        localStorage.removeItem("financials-panel-statetype");
        localStorage.removeItem("crisp");
        localStorage.removeItem("formula");
        localStorage.removeItem("stbx-active-trending-date");
        localStorage.removeItem("ws");
        features_orderbook_utils__WEBPACK_IMPORTED_MODULE_1__/* .localStorageOrderbookHandler.remove */ .Ku.remove();
        localStorage.removeItem("orderbooklistID");
        localStorage.removeItem("orderbooklistName");
    }
}
/**
 * getUserAccess
 * to get user data from auth login
 * @param {*} ctx
 */ function getUserAccess() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && localStorage && localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns] ? (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .decodeBase64ToJS */ .OB)(localStorage[constants_localstorage__WEBPACK_IMPORTED_MODULE_3__/* .ACCESS_USER_KEY */ .ns]) : {};
}
var setLocalCrispSettings = function(crisp) {
    localStorage.location = window.location.origin;
    localStorage.crisp = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(crisp);
};
var setLocalIntercomSettings = function(intercom) {
    localStorage.location = window.location.origin;
    localStorage.intercom = (0,_general__WEBPACK_IMPORTED_MODULE_2__/* .encodeBase64FromJS */ .me)(intercom);
};
var isLoggedIn = function() {
    return (0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)() && Boolean(localStorage === null || localStorage === void 0 ? void 0 : localStorage.at);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    isLoggedIn: isLoggedIn,
    getToken: getToken,
    saveToken: saveToken,
    destroyToken: destroyToken,
    getUserAccess: getUserAccess,
    updateAccessUser: updateAccessUser,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalIntercomSettings: setLocalIntercomSettings
});


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 17172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.5.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 94673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.6/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,88069,46819,97089,25935,7648,80129,51225,73216,2978,52134,92961,91036,54253,54005,33070,92077,95242,44912,21671,74768,12786,77284,74673,92636,49774,92888,40179], function() { return __webpack_exec__(10022); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);